"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var React = require("react");
var paths = require("./paths");
exports.SvgWrapper = function (pathObj) { return function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 512 512" }, props),
    React.createElement("path", __assign({}, pathObj)))); }; };
exports.Abstract001 = exports.SvgWrapper(paths.SvgAbstract001);
exports.Abstract002 = exports.SvgWrapper(paths.SvgAbstract002);
exports.Abstract003 = exports.SvgWrapper(paths.SvgAbstract003);
exports.Abstract004 = exports.SvgWrapper(paths.SvgAbstract004);
exports.Abstract005 = exports.SvgWrapper(paths.SvgAbstract005);
exports.Abstract006 = exports.SvgWrapper(paths.SvgAbstract006);
exports.Abstract007 = exports.SvgWrapper(paths.SvgAbstract007);
exports.Abstract008 = exports.SvgWrapper(paths.SvgAbstract008);
exports.Abstract009 = exports.SvgWrapper(paths.SvgAbstract009);
exports.Abstract010 = exports.SvgWrapper(paths.SvgAbstract010);
exports.Abstract011 = exports.SvgWrapper(paths.SvgAbstract011);
exports.Abstract012 = exports.SvgWrapper(paths.SvgAbstract012);
exports.Abstract013 = exports.SvgWrapper(paths.SvgAbstract013);
exports.Abstract014 = exports.SvgWrapper(paths.SvgAbstract014);
exports.Abstract015 = exports.SvgWrapper(paths.SvgAbstract015);
exports.Abstract016 = exports.SvgWrapper(paths.SvgAbstract016);
exports.Abstract017 = exports.SvgWrapper(paths.SvgAbstract017);
exports.Abstract018 = exports.SvgWrapper(paths.SvgAbstract018);
exports.Abstract019 = exports.SvgWrapper(paths.SvgAbstract019);
exports.Abstract020 = exports.SvgWrapper(paths.SvgAbstract020);
exports.Abstract021 = exports.SvgWrapper(paths.SvgAbstract021);
exports.Abstract022 = exports.SvgWrapper(paths.SvgAbstract022);
exports.Abstract023 = exports.SvgWrapper(paths.SvgAbstract023);
exports.Abstract024 = exports.SvgWrapper(paths.SvgAbstract024);
exports.Abstract025 = exports.SvgWrapper(paths.SvgAbstract025);
exports.Abstract026 = exports.SvgWrapper(paths.SvgAbstract026);
exports.Abstract027 = exports.SvgWrapper(paths.SvgAbstract027);
exports.Abstract028 = exports.SvgWrapper(paths.SvgAbstract028);
exports.Abstract029 = exports.SvgWrapper(paths.SvgAbstract029);
exports.Abstract030 = exports.SvgWrapper(paths.SvgAbstract030);
exports.Abstract031 = exports.SvgWrapper(paths.SvgAbstract031);
exports.Abstract032 = exports.SvgWrapper(paths.SvgAbstract032);
exports.Abstract033 = exports.SvgWrapper(paths.SvgAbstract033);
exports.Abstract034 = exports.SvgWrapper(paths.SvgAbstract034);
exports.Abstract035 = exports.SvgWrapper(paths.SvgAbstract035);
exports.Abstract036 = exports.SvgWrapper(paths.SvgAbstract036);
exports.Abstract037 = exports.SvgWrapper(paths.SvgAbstract037);
exports.Abstract038 = exports.SvgWrapper(paths.SvgAbstract038);
exports.Abstract039 = exports.SvgWrapper(paths.SvgAbstract039);
exports.Abstract040 = exports.SvgWrapper(paths.SvgAbstract040);
exports.Abstract041 = exports.SvgWrapper(paths.SvgAbstract041);
exports.Abstract042 = exports.SvgWrapper(paths.SvgAbstract042);
exports.Abstract043 = exports.SvgWrapper(paths.SvgAbstract043);
exports.Abstract044 = exports.SvgWrapper(paths.SvgAbstract044);
exports.Abstract045 = exports.SvgWrapper(paths.SvgAbstract045);
exports.Abstract046 = exports.SvgWrapper(paths.SvgAbstract046);
exports.Abstract047 = exports.SvgWrapper(paths.SvgAbstract047);
exports.Abstract048 = exports.SvgWrapper(paths.SvgAbstract048);
exports.Abstract049 = exports.SvgWrapper(paths.SvgAbstract049);
exports.Abstract050 = exports.SvgWrapper(paths.SvgAbstract050);
exports.Abstract051 = exports.SvgWrapper(paths.SvgAbstract051);
exports.Abstract052 = exports.SvgWrapper(paths.SvgAbstract052);
exports.Abstract053 = exports.SvgWrapper(paths.SvgAbstract053);
exports.Abstract054 = exports.SvgWrapper(paths.SvgAbstract054);
exports.Abstract055 = exports.SvgWrapper(paths.SvgAbstract055);
exports.Abstract056 = exports.SvgWrapper(paths.SvgAbstract056);
exports.Abstract057 = exports.SvgWrapper(paths.SvgAbstract057);
exports.Abstract058 = exports.SvgWrapper(paths.SvgAbstract058);
exports.Abstract059 = exports.SvgWrapper(paths.SvgAbstract059);
exports.Abstract060 = exports.SvgWrapper(paths.SvgAbstract060);
exports.Abstract061 = exports.SvgWrapper(paths.SvgAbstract061);
exports.Abstract062 = exports.SvgWrapper(paths.SvgAbstract062);
exports.Abstract063 = exports.SvgWrapper(paths.SvgAbstract063);
exports.Abstract064 = exports.SvgWrapper(paths.SvgAbstract064);
exports.Abstract065 = exports.SvgWrapper(paths.SvgAbstract065);
exports.Abstract066 = exports.SvgWrapper(paths.SvgAbstract066);
exports.Abstract067 = exports.SvgWrapper(paths.SvgAbstract067);
exports.Abstract068 = exports.SvgWrapper(paths.SvgAbstract068);
exports.Abstract069 = exports.SvgWrapper(paths.SvgAbstract069);
exports.Abstract070 = exports.SvgWrapper(paths.SvgAbstract070);
exports.Abstract071 = exports.SvgWrapper(paths.SvgAbstract071);
exports.Abstract072 = exports.SvgWrapper(paths.SvgAbstract072);
exports.Abstract073 = exports.SvgWrapper(paths.SvgAbstract073);
exports.Abstract074 = exports.SvgWrapper(paths.SvgAbstract074);
exports.Abstract075 = exports.SvgWrapper(paths.SvgAbstract075);
exports.Abstract076 = exports.SvgWrapper(paths.SvgAbstract076);
exports.Abstract077 = exports.SvgWrapper(paths.SvgAbstract077);
exports.Abstract078 = exports.SvgWrapper(paths.SvgAbstract078);
exports.Abstract079 = exports.SvgWrapper(paths.SvgAbstract079);
exports.Abstract080 = exports.SvgWrapper(paths.SvgAbstract080);
exports.Abstract081 = exports.SvgWrapper(paths.SvgAbstract081);
exports.Abstract082 = exports.SvgWrapper(paths.SvgAbstract082);
exports.Abstract083 = exports.SvgWrapper(paths.SvgAbstract083);
exports.Abstract084 = exports.SvgWrapper(paths.SvgAbstract084);
exports.Abstract085 = exports.SvgWrapper(paths.SvgAbstract085);
exports.Abstract086 = exports.SvgWrapper(paths.SvgAbstract086);
exports.Abstract087 = exports.SvgWrapper(paths.SvgAbstract087);
exports.Abstract088 = exports.SvgWrapper(paths.SvgAbstract088);
exports.Abstract089 = exports.SvgWrapper(paths.SvgAbstract089);
exports.Abstract090 = exports.SvgWrapper(paths.SvgAbstract090);
exports.Abstract091 = exports.SvgWrapper(paths.SvgAbstract091);
exports.Abstract092 = exports.SvgWrapper(paths.SvgAbstract092);
exports.Abstract093 = exports.SvgWrapper(paths.SvgAbstract093);
exports.Abstract094 = exports.SvgWrapper(paths.SvgAbstract094);
exports.Abstract095 = exports.SvgWrapper(paths.SvgAbstract095);
exports.Abstract096 = exports.SvgWrapper(paths.SvgAbstract096);
exports.Abstract097 = exports.SvgWrapper(paths.SvgAbstract097);
exports.Abstract098 = exports.SvgWrapper(paths.SvgAbstract098);
exports.Abstract099 = exports.SvgWrapper(paths.SvgAbstract099);
exports.Abstract100 = exports.SvgWrapper(paths.SvgAbstract100);
exports.Abstract101 = exports.SvgWrapper(paths.SvgAbstract101);
exports.Abstract102 = exports.SvgWrapper(paths.SvgAbstract102);
exports.Abstract103 = exports.SvgWrapper(paths.SvgAbstract103);
exports.Abstract104 = exports.SvgWrapper(paths.SvgAbstract104);
exports.Abstract105 = exports.SvgWrapper(paths.SvgAbstract105);
exports.Abstract106 = exports.SvgWrapper(paths.SvgAbstract106);
exports.Abstract107 = exports.SvgWrapper(paths.SvgAbstract107);
exports.Abstract108 = exports.SvgWrapper(paths.SvgAbstract108);
exports.Abstract109 = exports.SvgWrapper(paths.SvgAbstract109);
exports.Abstract110 = exports.SvgWrapper(paths.SvgAbstract110);
exports.Abstract111 = exports.SvgWrapper(paths.SvgAbstract111);
exports.Abstract112 = exports.SvgWrapper(paths.SvgAbstract112);
exports.Abstract113 = exports.SvgWrapper(paths.SvgAbstract113);
exports.Abstract114 = exports.SvgWrapper(paths.SvgAbstract114);
exports.Abstract115 = exports.SvgWrapper(paths.SvgAbstract115);
exports.Abstract116 = exports.SvgWrapper(paths.SvgAbstract116);
exports.Abstract117 = exports.SvgWrapper(paths.SvgAbstract117);
exports.Abstract118 = exports.SvgWrapper(paths.SvgAbstract118);
exports.Abstract119 = exports.SvgWrapper(paths.SvgAbstract119);
exports.Abstract120 = exports.SvgWrapper(paths.SvgAbstract120);
exports.Abstract121 = exports.SvgWrapper(paths.SvgAbstract121);
exports.Ace = exports.SvgWrapper(paths.SvgAce);
exports.Achievement = exports.SvgWrapper(paths.SvgAchievement);
exports.Acid = exports.SvgWrapper(paths.SvgAcid);
exports.AcidBlob = exports.SvgWrapper(paths.SvgAcidBlob);
exports.AcidTube = exports.SvgWrapper(paths.SvgAcidTube);
exports.Acorn = exports.SvgWrapper(paths.SvgAcorn);
exports.Acrobatic = exports.SvgWrapper(paths.SvgAcrobatic);
exports.AerialSignal = exports.SvgWrapper(paths.SvgAerialSignal);
exports.AerodynamicHarpoon = exports.SvgWrapper(paths.SvgAerodynamicHarpoon);
exports.Aerosol = exports.SvgWrapper(paths.SvgAerosol);
exports.Afterburn = exports.SvgWrapper(paths.SvgAfterburn);
exports.AirZigzag = exports.SvgWrapper(paths.SvgAirZigzag);
exports.Airplane = exports.SvgWrapper(paths.SvgAirplane);
exports.Ak47 = exports.SvgWrapper(paths.SvgAk47);
exports.Ak47U = exports.SvgWrapper(paths.SvgAk47U);
exports.AlienFire = exports.SvgWrapper(paths.SvgAlienFire);
exports.AlienSkull = exports.SvgWrapper(paths.SvgAlienSkull);
exports.AlienStare = exports.SvgWrapper(paths.SvgAlienStare);
exports.AllForOne = exports.SvgWrapper(paths.SvgAllForOne);
exports.AlliedStar = exports.SvgWrapper(paths.SvgAlliedStar);
exports.AlligatorClip = exports.SvgWrapper(paths.SvgAlligatorClip);
exports.Amethyst = exports.SvgWrapper(paths.SvgAmethyst);
exports.AmmoBox = exports.SvgWrapper(paths.SvgAmmoBox);
exports.Ammonite = exports.SvgWrapper(paths.SvgAmmonite);
exports.AmmoniteFossil = exports.SvgWrapper(paths.SvgAmmoniteFossil);
exports.Amplitude = exports.SvgWrapper(paths.SvgAmplitude);
exports.Amputation = exports.SvgWrapper(paths.SvgAmputation);
exports.Anatomy = exports.SvgWrapper(paths.SvgAnatomy);
exports.Anchor = exports.SvgWrapper(paths.SvgAnchor);
exports.AndroidMask = exports.SvgWrapper(paths.SvgAndroidMask);
exports.AndromedaChain = exports.SvgWrapper(paths.SvgAndromedaChain);
exports.AngelOutfit = exports.SvgWrapper(paths.SvgAngelOutfit);
exports.AngelWings = exports.SvgWrapper(paths.SvgAngelWings);
exports.AnglerFish = exports.SvgWrapper(paths.SvgAnglerFish);
exports.AngularSpider = exports.SvgWrapper(paths.SvgAngularSpider);
exports.AnimalSkull = exports.SvgWrapper(paths.SvgAnimalSkull);
exports.Ankh = exports.SvgWrapper(paths.SvgAnkh);
exports.Annexation = exports.SvgWrapper(paths.SvgAnnexation);
exports.Anthem = exports.SvgWrapper(paths.SvgAnthem);
exports.Anvil = exports.SvgWrapper(paths.SvgAnvil);
exports.AnvilImpact = exports.SvgWrapper(paths.SvgAnvilImpact);
exports.Apc = exports.SvgWrapper(paths.SvgApc);
exports.Apothecary = exports.SvgWrapper(paths.SvgApothecary);
exports.AppleMaggot = exports.SvgWrapper(paths.SvgAppleMaggot);
exports.AppleSeeds = exports.SvgWrapper(paths.SvgAppleSeeds);
exports.ArcheryTarget = exports.SvgWrapper(paths.SvgArcheryTarget);
exports.ArchitectMask = exports.SvgWrapper(paths.SvgArchitectMask);
exports.ArcingBolt = exports.SvgWrapper(paths.SvgArcingBolt);
exports.Arena = exports.SvgWrapper(paths.SvgArena);
exports.ArmadilloTail = exports.SvgWrapper(paths.SvgArmadilloTail);
exports.ArmorVest = exports.SvgWrapper(paths.SvgArmorVest);
exports.ArmoredPants = exports.SvgWrapper(paths.SvgArmoredPants);
exports.ArmouredShell = exports.SvgWrapper(paths.SvgArmouredShell);
exports.ArrowCluster = exports.SvgWrapper(paths.SvgArrowCluster);
exports.ArrowDunk = exports.SvgWrapper(paths.SvgArrowDunk);
exports.ArrowFlights = exports.SvgWrapper(paths.SvgArrowFlights);
exports.ArrowScope = exports.SvgWrapper(paths.SvgArrowScope);
exports.Arrowed = exports.SvgWrapper(paths.SvgArrowed);
exports.Arrowhead = exports.SvgWrapper(paths.SvgArrowhead);
exports.ArrowsShield = exports.SvgWrapper(paths.SvgArrowsShield);
exports.Arson = exports.SvgWrapper(paths.SvgArson);
exports.ArtificialHive = exports.SvgWrapper(paths.SvgArtificialHive);
exports.ArtificialIntelligence = exports.SvgWrapper(paths.SvgArtificialIntelligence);
exports.ArtilleryShell = exports.SvgWrapper(paths.SvgArtilleryShell);
exports.AssassinPocket = exports.SvgWrapper(paths.SvgAssassinPocket);
exports.AtSea = exports.SvgWrapper(paths.SvgAtSea);
exports.Atom = exports.SvgWrapper(paths.SvgAtom);
exports.AtomicSlashes = exports.SvgWrapper(paths.SvgAtomicSlashes);
exports.Aubergine = exports.SvgWrapper(paths.SvgAubergine);
exports.Aura = exports.SvgWrapper(paths.SvgAura);
exports.AutoRepair = exports.SvgWrapper(paths.SvgAutoRepair);
exports.Autogun = exports.SvgWrapper(paths.SvgAutogun);
exports.AutomaticSas = exports.SvgWrapper(paths.SvgAutomaticSas);
exports.Awareness = exports.SvgWrapper(paths.SvgAwareness);
exports.AxeInStump = exports.SvgWrapper(paths.SvgAxeInStump);
exports.AxeSwing = exports.SvgWrapper(paths.SvgAxeSwing);
exports.BackForth = exports.SvgWrapper(paths.SvgBackForth);
exports.BackPain = exports.SvgWrapper(paths.SvgBackPain);
exports.BackboneShell = exports.SvgWrapper(paths.SvgBackboneShell);
exports.Backstab = exports.SvgWrapper(paths.SvgBackstab);
exports.Backup = exports.SvgWrapper(paths.SvgBackup);
exports.BadGnome = exports.SvgWrapper(paths.SvgBadGnome);
exports.Balaclava = exports.SvgWrapper(paths.SvgBalaclava);
exports.Balkenkreuz = exports.SvgWrapper(paths.SvgBalkenkreuz);
exports.BallGlow = exports.SvgWrapper(paths.SvgBallGlow);
exports.BallHeart = exports.SvgWrapper(paths.SvgBallHeart);
exports.Ballista = exports.SvgWrapper(paths.SvgBallista);
exports.Balloons = exports.SvgWrapper(paths.SvgBalloons);
exports.BandageRoll = exports.SvgWrapper(paths.SvgBandageRoll);
exports.Bandaged = exports.SvgWrapper(paths.SvgBandaged);
exports.BarbedArrow = exports.SvgWrapper(paths.SvgBarbedArrow);
exports.BarbedCoil = exports.SvgWrapper(paths.SvgBarbedCoil);
exports.BarbedNails = exports.SvgWrapper(paths.SvgBarbedNails);
exports.BarbedSpear = exports.SvgWrapper(paths.SvgBarbedSpear);
exports.BarbedStar = exports.SvgWrapper(paths.SvgBarbedStar);
exports.BarbedSun = exports.SvgWrapper(paths.SvgBarbedSun);
exports.BarbedWire = exports.SvgWrapper(paths.SvgBarbedWire);
exports.Barbute = exports.SvgWrapper(paths.SvgBarbute);
exports.Barefoot = exports.SvgWrapper(paths.SvgBarefoot);
exports.Bat = exports.SvgWrapper(paths.SvgBat);
exports.BatBlade = exports.SvgWrapper(paths.SvgBatBlade);
exports.BatWing = exports.SvgWrapper(paths.SvgBatWing);
exports.Baton = exports.SvgWrapper(paths.SvgBaton);
exports.BatteredAxe = exports.SvgWrapper(paths.SvgBatteredAxe);
exports.Batteries = exports.SvgWrapper(paths.SvgBatteries);
exports.Battery0 = exports.SvgWrapper(paths.SvgBattery0);
exports.Battery100 = exports.SvgWrapper(paths.SvgBattery100);
exports.Battery25 = exports.SvgWrapper(paths.SvgBattery25);
exports.Battery50 = exports.SvgWrapper(paths.SvgBattery50);
exports.Battery75 = exports.SvgWrapper(paths.SvgBattery75);
exports.BatteryMinus = exports.SvgWrapper(paths.SvgBatteryMinus);
exports.BatteryPack = exports.SvgWrapper(paths.SvgBatteryPack);
exports.BatteryPackAlt = exports.SvgWrapper(paths.SvgBatteryPackAlt);
exports.BatteryPlus = exports.SvgWrapper(paths.SvgBatteryPlus);
exports.BattleAxe = exports.SvgWrapper(paths.SvgBattleAxe);
exports.BattleGear = exports.SvgWrapper(paths.SvgBattleGear);
exports.BattleTank = exports.SvgWrapper(paths.SvgBattleTank);
exports.Battleship = exports.SvgWrapper(paths.SvgBattleship);
exports.BatwingEmblem = exports.SvgWrapper(paths.SvgBatwingEmblem);
exports.Bayonet = exports.SvgWrapper(paths.SvgBayonet);
exports.BeamWake = exports.SvgWrapper(paths.SvgBeamWake);
exports.BeamsAura = exports.SvgWrapper(paths.SvgBeamsAura);
exports.Beanstalk = exports.SvgWrapper(paths.SvgBeanstalk);
exports.BearFace = exports.SvgWrapper(paths.SvgBearFace);
exports.Beard = exports.SvgWrapper(paths.SvgBeard);
exports.BeastEye = exports.SvgWrapper(paths.SvgBeastEye);
exports.Bee = exports.SvgWrapper(paths.SvgBee);
exports.Beech = exports.SvgWrapper(paths.SvgBeech);
exports.BeerStein = exports.SvgWrapper(paths.SvgBeerStein);
exports.BeetleShell = exports.SvgWrapper(paths.SvgBeetleShell);
exports.Behold = exports.SvgWrapper(paths.SvgBehold);
exports.BellShield = exports.SvgWrapper(paths.SvgBellShield);
exports.Belt = exports.SvgWrapper(paths.SvgBelt);
exports.BeltBuckles = exports.SvgWrapper(paths.SvgBeltBuckles);
exports.BestialFangs = exports.SvgWrapper(paths.SvgBestialFangs);
exports.BeveledStar = exports.SvgWrapper(paths.SvgBeveledStar);
exports.BigDiamondRing = exports.SvgWrapper(paths.SvgBigDiamondRing);
exports.BigEgg = exports.SvgWrapper(paths.SvgBigEgg);
exports.BigGear = exports.SvgWrapper(paths.SvgBigGear);
exports.BigWave = exports.SvgWrapper(paths.SvgBigWave);
exports.Biohazard = exports.SvgWrapper(paths.SvgBiohazard);
exports.Biplane = exports.SvgWrapper(paths.SvgBiplane);
exports.BirdClaw = exports.SvgWrapper(paths.SvgBirdClaw);
exports.BirdLimb = exports.SvgWrapper(paths.SvgBirdLimb);
exports.BirdMask = exports.SvgWrapper(paths.SvgBirdMask);
exports.BirdTwitter = exports.SvgWrapper(paths.SvgBirdTwitter);
exports.BlackBar = exports.SvgWrapper(paths.SvgBlackBar);
exports.BlackBook = exports.SvgWrapper(paths.SvgBlackBook);
exports.BlackFlag = exports.SvgWrapper(paths.SvgBlackFlag);
exports.BlackHandShield = exports.SvgWrapper(paths.SvgBlackHandShield);
exports.BlackHoleBolas = exports.SvgWrapper(paths.SvgBlackHoleBolas);
exports.Blackball = exports.SvgWrapper(paths.SvgBlackball);
exports.Blackcurrant = exports.SvgWrapper(paths.SvgBlackcurrant);
exports.BladeBite = exports.SvgWrapper(paths.SvgBladeBite);
exports.BladeDrag = exports.SvgWrapper(paths.SvgBladeDrag);
exports.BladeFall = exports.SvgWrapper(paths.SvgBladeFall);
exports.Blast = exports.SvgWrapper(paths.SvgBlast);
exports.Blaster = exports.SvgWrapper(paths.SvgBlaster);
exports.BleedingEye = exports.SvgWrapper(paths.SvgBleedingEye);
exports.BleedingHeart = exports.SvgWrapper(paths.SvgBleedingHeart);
exports.BleedingWound = exports.SvgWrapper(paths.SvgBleedingWound);
exports.Blood = exports.SvgWrapper(paths.SvgBlood);
exports.BloodyStash = exports.SvgWrapper(paths.SvgBloodyStash);
exports.BloodySword = exports.SvgWrapper(paths.SvgBloodySword);
exports.Blunderbuss = exports.SvgWrapper(paths.SvgBlunderbuss);
exports.BoarEnsign = exports.SvgWrapper(paths.SvgBoarEnsign);
exports.BoarTusks = exports.SvgWrapper(paths.SvgBoarTusks);
exports.BodySwapping = exports.SvgWrapper(paths.SvgBodySwapping);
exports.BoilingBubbles = exports.SvgWrapper(paths.SvgBoilingBubbles);
exports.Bolas = exports.SvgWrapper(paths.SvgBolas);
exports.BoltEye = exports.SvgWrapper(paths.SvgBoltEye);
exports.BoltSaw = exports.SvgWrapper(paths.SvgBoltSaw);
exports.BoltShield = exports.SvgWrapper(paths.SvgBoltShield);
exports.BolterGun = exports.SvgWrapper(paths.SvgBolterGun);
exports.Bomber = exports.SvgWrapper(paths.SvgBomber);
exports.BombingRun = exports.SvgWrapper(paths.SvgBombingRun);
exports.BoneGnawer = exports.SvgWrapper(paths.SvgBoneGnawer);
exports.BoneKnife = exports.SvgWrapper(paths.SvgBoneKnife);
exports.BookAura = exports.SvgWrapper(paths.SvgBookAura);
exports.BookCover = exports.SvgWrapper(paths.SvgBookCover);
exports.BookStorm = exports.SvgWrapper(paths.SvgBookStorm);
exports.Bookmark = exports.SvgWrapper(paths.SvgBookmark);
exports.Bookmarklet = exports.SvgWrapper(paths.SvgBookmarklet);
exports.BoomerangSun = exports.SvgWrapper(paths.SvgBoomerangSun);
exports.BootKick = exports.SvgWrapper(paths.SvgBootKick);
exports.BootPrints = exports.SvgWrapper(paths.SvgBootPrints);
exports.BootStomp = exports.SvgWrapper(paths.SvgBootStomp);
exports.Boots = exports.SvgWrapper(paths.SvgBoots);
exports.BorderedShield = exports.SvgWrapper(paths.SvgBorderedShield);
exports.BottleVapors = exports.SvgWrapper(paths.SvgBottleVapors);
exports.BottledBolt = exports.SvgWrapper(paths.SvgBottledBolt);
exports.BottomRight3DArrow = exports.SvgWrapper(paths.SvgBottomRight3DArrow);
exports.BouncingSword = exports.SvgWrapper(paths.SvgBouncingSword);
exports.BowieKnife = exports.SvgWrapper(paths.SvgBowieKnife);
exports.BowlSpiral = exports.SvgWrapper(paths.SvgBowlSpiral);
exports.BowlingPropulsion = exports.SvgWrapper(paths.SvgBowlingPropulsion);
exports.Bowman = exports.SvgWrapper(paths.SvgBowman);
exports.BoxTrap = exports.SvgWrapper(paths.SvgBoxTrap);
exports.BoxingGlove = exports.SvgWrapper(paths.SvgBoxingGlove);
exports.BoxingGloveSurprise = exports.SvgWrapper(paths.SvgBoxingGloveSurprise);
exports.Bracers = exports.SvgWrapper(paths.SvgBracers);
exports.Brain = exports.SvgWrapper(paths.SvgBrain);
exports.BrainFreeze = exports.SvgWrapper(paths.SvgBrainFreeze);
exports.BrainStem = exports.SvgWrapper(paths.SvgBrainStem);
exports.Brainstorm = exports.SvgWrapper(paths.SvgBrainstorm);
exports.BranchArrow = exports.SvgWrapper(paths.SvgBranchArrow);
exports.BrandyBottle = exports.SvgWrapper(paths.SvgBrandyBottle);
exports.BrassEye = exports.SvgWrapper(paths.SvgBrassEye);
exports.BreakingChain = exports.SvgWrapper(paths.SvgBreakingChain);
exports.Breastplate = exports.SvgWrapper(paths.SvgBreastplate);
exports.Bridge = exports.SvgWrapper(paths.SvgBridge);
exports.BrightExplosion = exports.SvgWrapper(paths.SvgBrightExplosion);
exports.BroadDagger = exports.SvgWrapper(paths.SvgBroadDagger);
exports.BroadheadArrow = exports.SvgWrapper(paths.SvgBroadheadArrow);
exports.Broadsword = exports.SvgWrapper(paths.SvgBroadsword);
exports.BrodieHelmet = exports.SvgWrapper(paths.SvgBrodieHelmet);
exports.BrokenArrow = exports.SvgWrapper(paths.SvgBrokenArrow);
exports.BrokenBone = exports.SvgWrapper(paths.SvgBrokenBone);
exports.BrokenBottle = exports.SvgWrapper(paths.SvgBrokenBottle);
exports.BrokenHeart = exports.SvgWrapper(paths.SvgBrokenHeart);
exports.BrokenHeartZone = exports.SvgWrapper(paths.SvgBrokenHeartZone);
exports.BrokenRibbon = exports.SvgWrapper(paths.SvgBrokenRibbon);
exports.BrokenShield = exports.SvgWrapper(paths.SvgBrokenShield);
exports.BrokenSkull = exports.SvgWrapper(paths.SvgBrokenSkull);
exports.BrokenTablet = exports.SvgWrapper(paths.SvgBrokenTablet);
exports.BrutalHelm = exports.SvgWrapper(paths.SvgBrutalHelm);
exports.BubbleField = exports.SvgWrapper(paths.SvgBubbleField);
exports.Bubbles = exports.SvgWrapper(paths.SvgBubbles);
exports.BubblingBeam = exports.SvgWrapper(paths.SvgBubblingBeam);
exports.BubblingBowl = exports.SvgWrapper(paths.SvgBubblingBowl);
exports.BubblingFlask = exports.SvgWrapper(paths.SvgBubblingFlask);
exports.Bud = exports.SvgWrapper(paths.SvgBud);
exports.BugleCall = exports.SvgWrapper(paths.SvgBugleCall);
exports.Bulb = exports.SvgWrapper(paths.SvgBulb);
exports.Bull = exports.SvgWrapper(paths.SvgBull);
exports.BullHorns = exports.SvgWrapper(paths.SvgBullHorns);
exports.Bullets = exports.SvgWrapper(paths.SvgBullets);
exports.Bullseye = exports.SvgWrapper(paths.SvgBullseye);
exports.BundleGrenade = exports.SvgWrapper(paths.SvgBundleGrenade);
exports.Bunker = exports.SvgWrapper(paths.SvgBunker);
exports.BunkerAssault = exports.SvgWrapper(paths.SvgBunkerAssault);
exports.Burn = exports.SvgWrapper(paths.SvgBurn);
exports.BurningBlobs = exports.SvgWrapper(paths.SvgBurningBlobs);
exports.BurningBook = exports.SvgWrapper(paths.SvgBurningBook);
exports.BurningDot = exports.SvgWrapper(paths.SvgBurningDot);
exports.BurningEmbers = exports.SvgWrapper(paths.SvgBurningEmbers);
exports.BurningEye = exports.SvgWrapper(paths.SvgBurningEye);
exports.BurningMeteor = exports.SvgWrapper(paths.SvgBurningMeteor);
exports.BurningPassion = exports.SvgWrapper(paths.SvgBurningPassion);
exports.BurningRoundShot = exports.SvgWrapper(paths.SvgBurningRoundShot);
exports.BurningSkull = exports.SvgWrapper(paths.SvgBurningSkull);
exports.BurningTree = exports.SvgWrapper(paths.SvgBurningTree);
exports.BurstBlob = exports.SvgWrapper(paths.SvgBurstBlob);
exports.Butterfly = exports.SvgWrapper(paths.SvgButterfly);
exports.ButterflyKnife = exports.SvgWrapper(paths.SvgButterflyKnife);
exports.ButterflyWarning = exports.SvgWrapper(paths.SvgButterflyWarning);
exports.C96 = exports.SvgWrapper(paths.SvgC96);
exports.CagedBall = exports.SvgWrapper(paths.SvgCagedBall);
exports.CakeSlice = exports.SvgWrapper(paths.SvgCakeSlice);
exports.Caldera = exports.SvgWrapper(paths.SvgCaldera);
exports.Campfire = exports.SvgWrapper(paths.SvgCampfire);
exports.Cancel = exports.SvgWrapper(paths.SvgCancel);
exports.CandleFlame = exports.SvgWrapper(paths.SvgCandleFlame);
exports.CandleHolder = exports.SvgWrapper(paths.SvgCandleHolder);
exports.CandleLight = exports.SvgWrapper(paths.SvgCandleLight);
exports.CandleSkull = exports.SvgWrapper(paths.SvgCandleSkull);
exports.Candlebright = exports.SvgWrapper(paths.SvgCandlebright);
exports.Cannister = exports.SvgWrapper(paths.SvgCannister);
exports.Cannon = exports.SvgWrapper(paths.SvgCannon);
exports.CannonBall = exports.SvgWrapper(paths.SvgCannonBall);
exports.CannonShot = exports.SvgWrapper(paths.SvgCannonShot);
exports.Capitol = exports.SvgWrapper(paths.SvgCapitol);
exports.Card10Clubs = exports.SvgWrapper(paths.SvgCard10Clubs);
exports.Card10Diamonds = exports.SvgWrapper(paths.SvgCard10Diamonds);
exports.Card10Hearts = exports.SvgWrapper(paths.SvgCard10Hearts);
exports.Card10Spades = exports.SvgWrapper(paths.SvgCard10Spades);
exports.Card2Clubs = exports.SvgWrapper(paths.SvgCard2Clubs);
exports.Card2Diamonds = exports.SvgWrapper(paths.SvgCard2Diamonds);
exports.Card2Hearts = exports.SvgWrapper(paths.SvgCard2Hearts);
exports.Card2Spades = exports.SvgWrapper(paths.SvgCard2Spades);
exports.Card3Clubs = exports.SvgWrapper(paths.SvgCard3Clubs);
exports.Card3Diamonds = exports.SvgWrapper(paths.SvgCard3Diamonds);
exports.Card3Hearts = exports.SvgWrapper(paths.SvgCard3Hearts);
exports.Card3Spades = exports.SvgWrapper(paths.SvgCard3Spades);
exports.Card4Clubs = exports.SvgWrapper(paths.SvgCard4Clubs);
exports.Card4Diamonds = exports.SvgWrapper(paths.SvgCard4Diamonds);
exports.Card4Hearts = exports.SvgWrapper(paths.SvgCard4Hearts);
exports.Card4Spades = exports.SvgWrapper(paths.SvgCard4Spades);
exports.Card5Clubs = exports.SvgWrapper(paths.SvgCard5Clubs);
exports.Card5Diamonds = exports.SvgWrapper(paths.SvgCard5Diamonds);
exports.Card5Hearts = exports.SvgWrapper(paths.SvgCard5Hearts);
exports.Card5Spades = exports.SvgWrapper(paths.SvgCard5Spades);
exports.Card6Clubs = exports.SvgWrapper(paths.SvgCard6Clubs);
exports.Card6Diamonds = exports.SvgWrapper(paths.SvgCard6Diamonds);
exports.Card6Hearts = exports.SvgWrapper(paths.SvgCard6Hearts);
exports.Card6Spades = exports.SvgWrapper(paths.SvgCard6Spades);
exports.Card7Clubs = exports.SvgWrapper(paths.SvgCard7Clubs);
exports.Card7Diamonds = exports.SvgWrapper(paths.SvgCard7Diamonds);
exports.Card7Hearts = exports.SvgWrapper(paths.SvgCard7Hearts);
exports.Card7Spades = exports.SvgWrapper(paths.SvgCard7Spades);
exports.Card8Clubs = exports.SvgWrapper(paths.SvgCard8Clubs);
exports.Card8Diamonds = exports.SvgWrapper(paths.SvgCard8Diamonds);
exports.Card8Hearts = exports.SvgWrapper(paths.SvgCard8Hearts);
exports.Card8Spades = exports.SvgWrapper(paths.SvgCard8Spades);
exports.Card9Clubs = exports.SvgWrapper(paths.SvgCard9Clubs);
exports.Card9Diamonds = exports.SvgWrapper(paths.SvgCard9Diamonds);
exports.Card9Hearts = exports.SvgWrapper(paths.SvgCard9Hearts);
exports.Card9Spades = exports.SvgWrapper(paths.SvgCard9Spades);
exports.CardAceClubs = exports.SvgWrapper(paths.SvgCardAceClubs);
exports.CardAceDiamonds = exports.SvgWrapper(paths.SvgCardAceDiamonds);
exports.CardAceHearts = exports.SvgWrapper(paths.SvgCardAceHearts);
exports.CardAceSpades = exports.SvgWrapper(paths.SvgCardAceSpades);
exports.CardDiscard = exports.SvgWrapper(paths.SvgCardDiscard);
exports.CardDraw = exports.SvgWrapper(paths.SvgCardDraw);
exports.CardJackClubs = exports.SvgWrapper(paths.SvgCardJackClubs);
exports.CardJackDiamonds = exports.SvgWrapper(paths.SvgCardJackDiamonds);
exports.CardJackHearts = exports.SvgWrapper(paths.SvgCardJackHearts);
exports.CardJackSpades = exports.SvgWrapper(paths.SvgCardJackSpades);
exports.CardKingClubs = exports.SvgWrapper(paths.SvgCardKingClubs);
exports.CardKingDiamonds = exports.SvgWrapper(paths.SvgCardKingDiamonds);
exports.CardKingHearts = exports.SvgWrapper(paths.SvgCardKingHearts);
exports.CardKingSpades = exports.SvgWrapper(paths.SvgCardKingSpades);
exports.CardPick = exports.SvgWrapper(paths.SvgCardPick);
exports.CardPickup = exports.SvgWrapper(paths.SvgCardPickup);
exports.CardPlay = exports.SvgWrapper(paths.SvgCardPlay);
exports.CardQueenClubs = exports.SvgWrapper(paths.SvgCardQueenClubs);
exports.CardQueenDiamonds = exports.SvgWrapper(paths.SvgCardQueenDiamonds);
exports.CardQueenHearts = exports.SvgWrapper(paths.SvgCardQueenHearts);
exports.CardQueenSpades = exports.SvgWrapper(paths.SvgCardQueenSpades);
exports.CardRandom = exports.SvgWrapper(paths.SvgCardRandom);
exports.CargoCrane = exports.SvgWrapper(paths.SvgCargoCrane);
exports.Carillon = exports.SvgWrapper(paths.SvgCarillon);
exports.CarnivoreMouth = exports.SvgWrapper(paths.SvgCarnivoreMouth);
exports.Carnyx = exports.SvgWrapper(paths.SvgCarnyx);
exports.CarpetBombing = exports.SvgWrapper(paths.SvgCarpetBombing);
exports.Carrier = exports.SvgWrapper(paths.SvgCarrier);
exports.Carrion = exports.SvgWrapper(paths.SvgCarrion);
exports.Cartwheel = exports.SvgWrapper(paths.SvgCartwheel);
exports.Cash = exports.SvgWrapper(paths.SvgCash);
exports.Castle = exports.SvgWrapper(paths.SvgCastle);
exports.Cat = exports.SvgWrapper(paths.SvgCat);
exports.Catapult = exports.SvgWrapper(paths.SvgCatapult);
exports.Catch = exports.SvgWrapper(paths.SvgCatch);
exports.Cauldron = exports.SvgWrapper(paths.SvgCauldron);
exports.CelebrationFire = exports.SvgWrapper(paths.SvgCelebrationFire);
exports.CementShoes = exports.SvgWrapper(paths.SvgCementShoes);
exports.Centipede = exports.SvgWrapper(paths.SvgCentipede);
exports.ChainLightning = exports.SvgWrapper(paths.SvgChainLightning);
exports.ChainMail = exports.SvgWrapper(paths.SvgChainMail);
exports.ChainedArrowHeads = exports.SvgWrapper(paths.SvgChainedArrowHeads);
exports.ChainedHeart = exports.SvgWrapper(paths.SvgChainedHeart);
exports.Chaingun = exports.SvgWrapper(paths.SvgChaingun);
exports.ChaliceDrops = exports.SvgWrapper(paths.SvgChaliceDrops);
exports.ChameleonGlyph = exports.SvgWrapper(paths.SvgChameleonGlyph);
exports.ChargedArrow = exports.SvgWrapper(paths.SvgChargedArrow);
exports.Chariot = exports.SvgWrapper(paths.SvgChariot);
exports.Charm = exports.SvgWrapper(paths.SvgCharm);
exports.CheckboxTree = exports.SvgWrapper(paths.SvgCheckboxTree);
exports.CheckedShield = exports.SvgWrapper(paths.SvgCheckedShield);
exports.CheckeredDiamond = exports.SvgWrapper(paths.SvgCheckeredDiamond);
exports.Cheerful = exports.SvgWrapper(paths.SvgCheerful);
exports.CheeseWedge = exports.SvgWrapper(paths.SvgCheeseWedge);
exports.ChemicalArrow = exports.SvgWrapper(paths.SvgChemicalArrow);
exports.ChemicalBolt = exports.SvgWrapper(paths.SvgChemicalBolt);
exports.ChemicalDrop = exports.SvgWrapper(paths.SvgChemicalDrop);
exports.ChemicalTank = exports.SvgWrapper(paths.SvgChemicalTank);
exports.ChessBishop = exports.SvgWrapper(paths.SvgChessBishop);
exports.ChessKing = exports.SvgWrapper(paths.SvgChessKing);
exports.ChessKnight = exports.SvgWrapper(paths.SvgChessKnight);
exports.ChessPawn = exports.SvgWrapper(paths.SvgChessPawn);
exports.ChessQueen = exports.SvgWrapper(paths.SvgChessQueen);
exports.ChessRook = exports.SvgWrapper(paths.SvgChessRook);
exports.ChewedHeart = exports.SvgWrapper(paths.SvgChewedHeart);
exports.ChewedSkull = exports.SvgWrapper(paths.SvgChewedSkull);
exports.ChickenLeg = exports.SvgWrapper(paths.SvgChickenLeg);
exports.ChocolateBar = exports.SvgWrapper(paths.SvgChocolateBar);
exports.ChoppedSkull = exports.SvgWrapper(paths.SvgChoppedSkull);
exports.CircleCage = exports.SvgWrapper(paths.SvgCircleCage);
exports.CircleClaws = exports.SvgWrapper(paths.SvgCircleClaws);
exports.CircleSparks = exports.SvgWrapper(paths.SvgCircleSparks);
exports.Circuitry = exports.SvgWrapper(paths.SvgCircuitry);
exports.CircularSaw = exports.SvgWrapper(paths.SvgCircularSaw);
exports.CircularSawblade = exports.SvgWrapper(paths.SvgCircularSawblade);
exports.Claw = exports.SvgWrapper(paths.SvgClaw);
exports.ClawHammer = exports.SvgWrapper(paths.SvgClawHammer);
exports.ClawSlashes = exports.SvgWrapper(paths.SvgClawSlashes);
exports.ClawString = exports.SvgWrapper(paths.SvgClawString);
exports.Click = exports.SvgWrapper(paths.SvgClick);
exports.Cloak = exports.SvgWrapper(paths.SvgCloak);
exports.CloakDagger = exports.SvgWrapper(paths.SvgCloakDagger);
exports.Clockwork = exports.SvgWrapper(paths.SvgClockwork);
exports.CloudRing = exports.SvgWrapper(paths.SvgCloudRing);
exports.CloudyFork = exports.SvgWrapper(paths.SvgCloudyFork);
exports.Clout = exports.SvgWrapper(paths.SvgClout);
exports.Clover = exports.SvgWrapper(paths.SvgClover);
exports.CloverSpiked = exports.SvgWrapper(paths.SvgCloverSpiked);
exports.Clubs = exports.SvgWrapper(paths.SvgClubs);
exports.ClusterBomb = exports.SvgWrapper(paths.SvgClusterBomb);
exports.Cobra = exports.SvgWrapper(paths.SvgCobra);
exports.Cobweb = exports.SvgWrapper(paths.SvgCobweb);
exports.CoffeeMug = exports.SvgWrapper(paths.SvgCoffeeMug);
exports.Coffin = exports.SvgWrapper(paths.SvgCoffin);
exports.Cog = exports.SvgWrapper(paths.SvgCog);
exports.CogLock = exports.SvgWrapper(paths.SvgCogLock);
exports.Cogsplosion = exports.SvgWrapper(paths.SvgCogsplosion);
exports.CoilingCurl = exports.SvgWrapper(paths.SvgCoilingCurl);
exports.ColdHeart = exports.SvgWrapper(paths.SvgColdHeart);
exports.ColtM1911 = exports.SvgWrapper(paths.SvgColtM1911);
exports.Coma = exports.SvgWrapper(paths.SvgComa);
exports.Comb = exports.SvgWrapper(paths.SvgComb);
exports.CombinationLock = exports.SvgWrapper(paths.SvgCombinationLock);
exports.CometSpark = exports.SvgWrapper(paths.SvgCometSpark);
exports.Compass = exports.SvgWrapper(paths.SvgCompass);
exports.Computing = exports.SvgWrapper(paths.SvgComputing);
exports.ConcentrationOrb = exports.SvgWrapper(paths.SvgConcentrationOrb);
exports.ConcentricCrescents = exports.SvgWrapper(paths.SvgConcentricCrescents);
exports.CondorEmblem = exports.SvgWrapper(paths.SvgCondorEmblem);
exports.CondyluraSkull = exports.SvgWrapper(paths.SvgCondyluraSkull);
exports.ConsoleController = exports.SvgWrapper(paths.SvgConsoleController);
exports.Conversation = exports.SvgWrapper(paths.SvgConversation);
exports.CoolSpices = exports.SvgWrapper(paths.SvgCoolSpices);
exports.CorkedTube = exports.SvgWrapper(paths.SvgCorkedTube);
exports.CornerExplosion = exports.SvgWrapper(paths.SvgCornerExplosion);
exports.Cowled = exports.SvgWrapper(paths.SvgCowled);
exports.CpuShot = exports.SvgWrapper(paths.SvgCpuShot);
exports.Crab = exports.SvgWrapper(paths.SvgCrab);
exports.CrabClaw = exports.SvgWrapper(paths.SvgCrabClaw);
exports.CrackedAlienSkull = exports.SvgWrapper(paths.SvgCrackedAlienSkull);
exports.CrackedBallDunk = exports.SvgWrapper(paths.SvgCrackedBallDunk);
exports.CrackedDisc = exports.SvgWrapper(paths.SvgCrackedDisc);
exports.CrackedGlass = exports.SvgWrapper(paths.SvgCrackedGlass);
exports.CrackedHelm = exports.SvgWrapper(paths.SvgCrackedHelm);
exports.CrackedMask = exports.SvgWrapper(paths.SvgCrackedMask);
exports.CrackedSaber = exports.SvgWrapper(paths.SvgCrackedSaber);
exports.CrackedShield = exports.SvgWrapper(paths.SvgCrackedShield);
exports.Crags = exports.SvgWrapper(paths.SvgCrags);
exports.CrenulatedShield = exports.SvgWrapper(paths.SvgCrenulatedShield);
exports.CrescentBlade = exports.SvgWrapper(paths.SvgCrescentBlade);
exports.CrestedHelmet = exports.SvgWrapper(paths.SvgCrestedHelmet);
exports.CrocJaws = exports.SvgWrapper(paths.SvgCrocJaws);
exports.CrocSword = exports.SvgWrapper(paths.SvgCrocSword);
exports.CroissantsPupil = exports.SvgWrapper(paths.SvgCroissantsPupil);
exports.CrossFlare = exports.SvgWrapper(paths.SvgCrossFlare);
exports.CrossMark = exports.SvgWrapper(paths.SvgCrossMark);
exports.Crossbow = exports.SvgWrapper(paths.SvgCrossbow);
exports.CrossedAirFlows = exports.SvgWrapper(paths.SvgCrossedAirFlows);
exports.CrossedAxes = exports.SvgWrapper(paths.SvgCrossedAxes);
exports.CrossedBones = exports.SvgWrapper(paths.SvgCrossedBones);
exports.CrossedChains = exports.SvgWrapper(paths.SvgCrossedChains);
exports.CrossedClaws = exports.SvgWrapper(paths.SvgCrossedClaws);
exports.CrossedPistols = exports.SvgWrapper(paths.SvgCrossedPistols);
exports.CrossedSabres = exports.SvgWrapper(paths.SvgCrossedSabres);
exports.CrossedSlashes = exports.SvgWrapper(paths.SvgCrossedSlashes);
exports.CrossedSwords = exports.SvgWrapper(paths.SvgCrossedSwords);
exports.CrosshairArrow = exports.SvgWrapper(paths.SvgCrosshairArrow);
exports.CrowDive = exports.SvgWrapper(paths.SvgCrowDive);
exports.Crown = exports.SvgWrapper(paths.SvgCrown);
exports.CrownCoin = exports.SvgWrapper(paths.SvgCrownCoin);
exports.CrownOfThorns = exports.SvgWrapper(paths.SvgCrownOfThorns);
exports.CrownedExplosion = exports.SvgWrapper(paths.SvgCrownedExplosion);
exports.CrownedHeart = exports.SvgWrapper(paths.SvgCrownedHeart);
exports.CrownedSkull = exports.SvgWrapper(paths.SvgCrownedSkull);
exports.Cruiser = exports.SvgWrapper(paths.SvgCruiser);
exports.CrumblingBall = exports.SvgWrapper(paths.SvgCrumblingBall);
exports.Crush = exports.SvgWrapper(paths.SvgCrush);
exports.CrystalBall = exports.SvgWrapper(paths.SvgCrystalBall);
exports.CrystalBars = exports.SvgWrapper(paths.SvgCrystalBars);
exports.CrystalCluster = exports.SvgWrapper(paths.SvgCrystalCluster);
exports.CrystalEye = exports.SvgWrapper(paths.SvgCrystalEye);
exports.CrystalGrowth = exports.SvgWrapper(paths.SvgCrystalGrowth);
exports.CrystalShine = exports.SvgWrapper(paths.SvgCrystalShine);
exports.CrystalWand = exports.SvgWrapper(paths.SvgCrystalWand);
exports.Crystalize = exports.SvgWrapper(paths.SvgCrystalize);
exports.Cubeforce = exports.SvgWrapper(paths.SvgCubeforce);
exports.Cubes = exports.SvgWrapper(paths.SvgCubes);
exports.Cultist = exports.SvgWrapper(paths.SvgCultist);
exports.CupidonArrow = exports.SvgWrapper(paths.SvgCupidonArrow);
exports.CurledLeaf = exports.SvgWrapper(paths.SvgCurledLeaf);
exports.CurledTentacle = exports.SvgWrapper(paths.SvgCurledTentacle);
exports.CurlingVines = exports.SvgWrapper(paths.SvgCurlingVines);
exports.CurlyMask = exports.SvgWrapper(paths.SvgCurlyMask);
exports.CurlyWing = exports.SvgWrapper(paths.SvgCurlyWing);
exports.CursedStar = exports.SvgWrapper(paths.SvgCursedStar);
exports.CurvyKnife = exports.SvgWrapper(paths.SvgCurvyKnife);
exports.CutDiamond = exports.SvgWrapper(paths.SvgCutDiamond);
exports.CutPalm = exports.SvgWrapper(paths.SvgCutPalm);
exports.Cycle = exports.SvgWrapper(paths.SvgCycle);
exports.Cyclops = exports.SvgWrapper(paths.SvgCyclops);
exports.CzSkorpion = exports.SvgWrapper(paths.SvgCzSkorpion);
exports.D10 = exports.SvgWrapper(paths.SvgD10);
exports.D12 = exports.SvgWrapper(paths.SvgD12);
exports.D4 = exports.SvgWrapper(paths.SvgD4);
exports.DaemonSkull = exports.SvgWrapper(paths.SvgDaemonSkull);
exports.Daggers = exports.SvgWrapper(paths.SvgDaggers);
exports.Daisy = exports.SvgWrapper(paths.SvgDaisy);
exports.DamagedHouse = exports.SvgWrapper(paths.SvgDamagedHouse);
exports.DarkSquad = exports.SvgWrapper(paths.SvgDarkSquad);
exports.DeadEye = exports.SvgWrapper(paths.SvgDeadEye);
exports.DeadWood = exports.SvgWrapper(paths.SvgDeadWood);
exports.DeadlyStrike = exports.SvgWrapper(paths.SvgDeadlyStrike);
exports.DeathJuice = exports.SvgWrapper(paths.SvgDeathJuice);
exports.DeathNote = exports.SvgWrapper(paths.SvgDeathNote);
exports.DeathSkull = exports.SvgWrapper(paths.SvgDeathSkull);
exports.DeathZone = exports.SvgWrapper(paths.SvgDeathZone);
exports.Deathcab = exports.SvgWrapper(paths.SvgDeathcab);
exports.Decapitation = exports.SvgWrapper(paths.SvgDecapitation);
exports.DefensiveWall = exports.SvgWrapper(paths.SvgDefensiveWall);
exports.Defibrilate = exports.SvgWrapper(paths.SvgDefibrilate);
exports.Delighted = exports.SvgWrapper(paths.SvgDelighted);
exports.Demolish = exports.SvgWrapper(paths.SvgDemolish);
exports.DervishSwords = exports.SvgWrapper(paths.SvgDervishSwords);
exports.DesertEagle = exports.SvgWrapper(paths.SvgDesertEagle);
exports.DesertSkull = exports.SvgWrapper(paths.SvgDesertSkull);
exports.DeskLamp = exports.SvgWrapper(paths.SvgDeskLamp);
exports.Despair = exports.SvgWrapper(paths.SvgDespair);
exports.Dew = exports.SvgWrapper(paths.SvgDew);
exports.DiabloSkull = exports.SvgWrapper(paths.SvgDiabloSkull);
exports.Diagram = exports.SvgWrapper(paths.SvgDiagram);
exports.DiamondHard = exports.SvgWrapper(paths.SvgDiamondHard);
exports.Diamonds = exports.SvgWrapper(paths.SvgDiamonds);
exports.DiamondsSmile = exports.SvgWrapper(paths.SvgDiamondsSmile);
exports.DigDug = exports.SvgWrapper(paths.SvgDigDug);
exports.DigitalTrace = exports.SvgWrapper(paths.SvgDigitalTrace);
exports.DinosaurBones = exports.SvgWrapper(paths.SvgDinosaurBones);
exports.DinosaurEgg = exports.SvgWrapper(paths.SvgDinosaurEgg);
exports.DinosaurRex = exports.SvgWrapper(paths.SvgDinosaurRex);
exports.Direwolf = exports.SvgWrapper(paths.SvgDirewolf);
exports.Disc = exports.SvgWrapper(paths.SvgDisc);
exports.Disintegrate = exports.SvgWrapper(paths.SvgDisintegrate);
exports.Distraction = exports.SvgWrapper(paths.SvgDistraction);
exports.Divergence = exports.SvgWrapper(paths.SvgDivergence);
exports.Divert = exports.SvgWrapper(paths.SvgDivert);
exports.DividedSpiral = exports.SvgWrapper(paths.SvgDividedSpiral);
exports.DividedSquare = exports.SvgWrapper(paths.SvgDividedSquare);
exports.DivingDagger = exports.SvgWrapper(paths.SvgDivingDagger);
exports.Dna1 = exports.SvgWrapper(paths.SvgDna1);
exports.Dna2 = exports.SvgWrapper(paths.SvgDna2);
exports.DoctorFace = exports.SvgWrapper(paths.SvgDoctorFace);
exports.Dodge = exports.SvgWrapper(paths.SvgDodge);
exports.Dodging = exports.SvgWrapper(paths.SvgDodging);
exports.DominoMask = exports.SvgWrapper(paths.SvgDominoMask);
exports.Donkey = exports.SvgWrapper(paths.SvgDonkey);
exports.Doorway = exports.SvgWrapper(paths.SvgDoorway);
exports.DorsalScales = exports.SvgWrapper(paths.SvgDorsalScales);
exports.DoubleDiaphragm = exports.SvgWrapper(paths.SvgDoubleDiaphragm);
exports.DoubleDragon = exports.SvgWrapper(paths.SvgDoubleDragon);
exports.DoubleFaceMask = exports.SvgWrapper(paths.SvgDoubleFaceMask);
exports.DoubleQuaver = exports.SvgWrapper(paths.SvgDoubleQuaver);
exports.DoubleRingedOrb = exports.SvgWrapper(paths.SvgDoubleRingedOrb);
exports.DoubleShot = exports.SvgWrapper(paths.SvgDoubleShot);
exports.Doubled = exports.SvgWrapper(paths.SvgDoubled);
exports.Dove = exports.SvgWrapper(paths.SvgDove);
exports.Dozen = exports.SvgWrapper(paths.SvgDozen);
exports.DragonBalls = exports.SvgWrapper(paths.SvgDragonBalls);
exports.DragonBreath = exports.SvgWrapper(paths.SvgDragonBreath);
exports.DragonHead = exports.SvgWrapper(paths.SvgDragonHead);
exports.DragonSpiral = exports.SvgWrapper(paths.SvgDragonSpiral);
exports.Dragonfly = exports.SvgWrapper(paths.SvgDragonfly);
exports.DramaMasks = exports.SvgWrapper(paths.SvgDramaMasks);
exports.Dread = exports.SvgWrapper(paths.SvgDread);
exports.DreadSkull = exports.SvgWrapper(paths.SvgDreadSkull);
exports.Dreadnought = exports.SvgWrapper(paths.SvgDreadnought);
exports.Dress = exports.SvgWrapper(paths.SvgDress);
exports.Drill = exports.SvgWrapper(paths.SvgDrill);
exports.DrinkMe = exports.SvgWrapper(paths.SvgDrinkMe);
exports.DrippingBlade = exports.SvgWrapper(paths.SvgDrippingBlade);
exports.DrippingGoo = exports.SvgWrapper(paths.SvgDrippingGoo);
exports.DrippingHoney = exports.SvgWrapper(paths.SvgDrippingHoney);
exports.DrippingKnife = exports.SvgWrapper(paths.SvgDrippingKnife);
exports.DrippingStar = exports.SvgWrapper(paths.SvgDrippingStar);
exports.DrippingStone = exports.SvgWrapper(paths.SvgDrippingStone);
exports.DrippingSword = exports.SvgWrapper(paths.SvgDrippingSword);
exports.DrippingTube = exports.SvgWrapper(paths.SvgDrippingTube);
exports.Drop = exports.SvgWrapper(paths.SvgDrop);
exports.DropWeapon = exports.SvgWrapper(paths.SvgDropWeapon);
exports.DropletSplash = exports.SvgWrapper(paths.SvgDropletSplash);
exports.Droplets = exports.SvgWrapper(paths.SvgDroplets);
exports.Drowning = exports.SvgWrapper(paths.SvgDrowning);
exports.Duality = exports.SvgWrapper(paths.SvgDuality);
exports.DualityMask = exports.SvgWrapper(paths.SvgDualityMask);
exports.Duel = exports.SvgWrapper(paths.SvgDuel);
exports.DustCloud = exports.SvgWrapper(paths.SvgDustCloud);
exports.DwarfHelmet = exports.SvgWrapper(paths.SvgDwarfHelmet);
exports.DwarfKing = exports.SvgWrapper(paths.SvgDwarfKing);
exports.EagleEmblem = exports.SvgWrapper(paths.SvgEagleEmblem);
exports.EarthCrack = exports.SvgWrapper(paths.SvgEarthCrack);
exports.EarthSpit = exports.SvgWrapper(paths.SvgEarthSpit);
exports.EarthWorm = exports.SvgWrapper(paths.SvgEarthWorm);
exports.Earwig = exports.SvgWrapper(paths.SvgEarwig);
exports.EchoRipples = exports.SvgWrapper(paths.SvgEchoRipples);
exports.Eclipse = exports.SvgWrapper(paths.SvgEclipse);
exports.EclipseFlare = exports.SvgWrapper(paths.SvgEclipseFlare);
exports.EclipseSaw = exports.SvgWrapper(paths.SvgEclipseSaw);
exports.EdgeCrack = exports.SvgWrapper(paths.SvgEdgeCrack);
exports.EdgedShield = exports.SvgWrapper(paths.SvgEdgedShield);
exports.EggClutch = exports.SvgWrapper(paths.SvgEggClutch);
exports.EggDefense = exports.SvgWrapper(paths.SvgEggDefense);
exports.EggPod = exports.SvgWrapper(paths.SvgEggPod);
exports.Elderberry = exports.SvgWrapper(paths.SvgElderberry);
exports.Electric = exports.SvgWrapper(paths.SvgElectric);
exports.ElectricWhip = exports.SvgWrapper(paths.SvgElectricWhip);
exports.ElectricalCrescent = exports.SvgWrapper(paths.SvgElectricalCrescent);
exports.ElfHelmet = exports.SvgWrapper(paths.SvgElfHelmet);
exports.ElvenCastle = exports.SvgWrapper(paths.SvgElvenCastle);
exports.EmberShot = exports.SvgWrapper(paths.SvgEmberShot);
exports.EmbrassedEnergy = exports.SvgWrapper(paths.SvgEmbrassedEnergy);
exports.Embryo = exports.SvgWrapper(paths.SvgEmbryo);
exports.Emerald = exports.SvgWrapper(paths.SvgEmerald);
exports.EmptyHourglass = exports.SvgWrapper(paths.SvgEmptyHourglass);
exports.Energise = exports.SvgWrapper(paths.SvgEnergise);
exports.EnergyArrow = exports.SvgWrapper(paths.SvgEnergyArrow);
exports.EnergyBreath = exports.SvgWrapper(paths.SvgEnergyBreath);
exports.EnergyShield = exports.SvgWrapper(paths.SvgEnergyShield);
exports.EnergySword = exports.SvgWrapper(paths.SvgEnergySword);
exports.EngagementRing = exports.SvgWrapper(paths.SvgEngagementRing);
exports.Enlightenment = exports.SvgWrapper(paths.SvgEnlightenment);
exports.EntMouth = exports.SvgWrapper(paths.SvgEntMouth);
exports.EntangledTyphoon = exports.SvgWrapper(paths.SvgEntangledTyphoon);
exports.Envelope = exports.SvgWrapper(paths.SvgEnvelope);
exports.Erlenmeyer = exports.SvgWrapper(paths.SvgErlenmeyer);
exports.Eruption = exports.SvgWrapper(paths.SvgEruption);
exports.Eskimo = exports.SvgWrapper(paths.SvgEskimo);
exports.EvilBat = exports.SvgWrapper(paths.SvgEvilBat);
exports.EvilBook = exports.SvgWrapper(paths.SvgEvilBook);
exports.EvilBud = exports.SvgWrapper(paths.SvgEvilBud);
exports.EvilComet = exports.SvgWrapper(paths.SvgEvilComet);
exports.EvilEyes = exports.SvgWrapper(paths.SvgEvilEyes);
exports.EvilFork = exports.SvgWrapper(paths.SvgEvilFork);
exports.EvilHand = exports.SvgWrapper(paths.SvgEvilHand);
exports.EvilMinion = exports.SvgWrapper(paths.SvgEvilMinion);
exports.EvilMoon = exports.SvgWrapper(paths.SvgEvilMoon);
exports.EvilTree = exports.SvgWrapper(paths.SvgEvilTree);
exports.EvilWings = exports.SvgWrapper(paths.SvgEvilWings);
exports.ExpandedRays = exports.SvgWrapper(paths.SvgExpandedRays);
exports.Expander = exports.SvgWrapper(paths.SvgExpander);
exports.ExplosionRays = exports.SvgWrapper(paths.SvgExplosionRays);
exports.ExplosiveMaterials = exports.SvgWrapper(paths.SvgExplosiveMaterials);
exports.ExplosiveMeeting = exports.SvgWrapper(paths.SvgExplosiveMeeting);
exports.ExtraLucid = exports.SvgWrapper(paths.SvgExtraLucid);
exports.ExtractionOrb = exports.SvgWrapper(paths.SvgExtractionOrb);
exports.EyeShield = exports.SvgWrapper(paths.SvgEyeShield);
exports.Eyeball = exports.SvgWrapper(paths.SvgEyeball);
exports.Eyedropper = exports.SvgWrapper(paths.SvgEyedropper);
exports.Eyestalk = exports.SvgWrapper(paths.SvgEyestalk);
exports.F1Car = exports.SvgWrapper(paths.SvgF1Car);
exports.Fairy = exports.SvgWrapper(paths.SvgFairy);
exports.FairyWand = exports.SvgWrapper(paths.SvgFairyWand);
exports.FallDown = exports.SvgWrapper(paths.SvgFallDown);
exports.Falling = exports.SvgWrapper(paths.SvgFalling);
exports.FallingBlob = exports.SvgWrapper(paths.SvgFallingBlob);
exports.FallingBoulder = exports.SvgWrapper(paths.SvgFallingBoulder);
exports.FallingEye = exports.SvgWrapper(paths.SvgFallingEye);
exports.FallingLeaf = exports.SvgWrapper(paths.SvgFallingLeaf);
exports.FallingOvoid = exports.SvgWrapper(paths.SvgFallingOvoid);
exports.Famas = exports.SvgWrapper(paths.SvgFamas);
exports.FangedSkull = exports.SvgWrapper(paths.SvgFangedSkull);
exports.Fangs = exports.SvgWrapper(paths.SvgFangs);
exports.FangsCircle = exports.SvgWrapper(paths.SvgFangsCircle);
exports.FastArrow = exports.SvgWrapper(paths.SvgFastArrow);
exports.Fat = exports.SvgWrapper(paths.SvgFat);
exports.Feather = exports.SvgWrapper(paths.SvgFeather);
exports.FeatherWound = exports.SvgWrapper(paths.SvgFeatherWound);
exports.FeatheredWing = exports.SvgWrapper(paths.SvgFeatheredWing);
exports.Fedora = exports.SvgWrapper(paths.SvgFedora);
exports.Fetus = exports.SvgWrapper(paths.SvgFetus);
exports.Field = exports.SvgWrapper(paths.SvgField);
exports.FieldGun = exports.SvgWrapper(paths.SvgFieldGun);
exports.FingersCrossed = exports.SvgWrapper(paths.SvgFingersCrossed);
exports.Fire = exports.SvgWrapper(paths.SvgFire);
exports.FireAce = exports.SvgWrapper(paths.SvgFireAce);
exports.FireAxe = exports.SvgWrapper(paths.SvgFireAxe);
exports.FireBomb = exports.SvgWrapper(paths.SvgFireBomb);
exports.FireBottle = exports.SvgWrapper(paths.SvgFireBottle);
exports.FireBowl = exports.SvgWrapper(paths.SvgFireBowl);
exports.FireBreath = exports.SvgWrapper(paths.SvgFireBreath);
exports.FireDash = exports.SvgWrapper(paths.SvgFireDash);
exports.FirePunch = exports.SvgWrapper(paths.SvgFirePunch);
exports.FireRay = exports.SvgWrapper(paths.SvgFireRay);
exports.FireRing = exports.SvgWrapper(paths.SvgFireRing);
exports.FireShield = exports.SvgWrapper(paths.SvgFireShield);
exports.FireSilhouette = exports.SvgWrapper(paths.SvgFireSilhouette);
exports.FireTail = exports.SvgWrapper(paths.SvgFireTail);
exports.FireWave = exports.SvgWrapper(paths.SvgFireWave);
exports.FireZone = exports.SvgWrapper(paths.SvgFireZone);
exports.Fireball = exports.SvgWrapper(paths.SvgFireball);
exports.Fireflake = exports.SvgWrapper(paths.SvgFireflake);
exports.FireworkRocket = exports.SvgWrapper(paths.SvgFireworkRocket);
exports.FishCooked = exports.SvgWrapper(paths.SvgFishCooked);
exports.FishCorpse = exports.SvgWrapper(paths.SvgFishCorpse);
exports.Fishbone = exports.SvgWrapper(paths.SvgFishbone);
exports.FishhookFork = exports.SvgWrapper(paths.SvgFishhookFork);
exports.FishingHook = exports.SvgWrapper(paths.SvgFishingHook);
exports.FishingNet = exports.SvgWrapper(paths.SvgFishingNet);
exports.Fission = exports.SvgWrapper(paths.SvgFission);
exports.Fist = exports.SvgWrapper(paths.SvgFist);
exports.FizzingFlask = exports.SvgWrapper(paths.SvgFizzingFlask);
exports.Flake = exports.SvgWrapper(paths.SvgFlake);
exports.Flame = exports.SvgWrapper(paths.SvgFlame);
exports.FlameClaws = exports.SvgWrapper(paths.SvgFlameClaws);
exports.FlameSpin = exports.SvgWrapper(paths.SvgFlameSpin);
exports.FlameTunnel = exports.SvgWrapper(paths.SvgFlameTunnel);
exports.FlamedLeaf = exports.SvgWrapper(paths.SvgFlamedLeaf);
exports.Flamer = exports.SvgWrapper(paths.SvgFlamer);
exports.FlamingArrow = exports.SvgWrapper(paths.SvgFlamingArrow);
exports.FlamingClaw = exports.SvgWrapper(paths.SvgFlamingClaw);
exports.FlamingSheet = exports.SvgWrapper(paths.SvgFlamingSheet);
exports.FlamingTrident = exports.SvgWrapper(paths.SvgFlamingTrident);
exports.FlashGrenade = exports.SvgWrapper(paths.SvgFlashGrenade);
exports.FlatHammer = exports.SvgWrapper(paths.SvgFlatHammer);
exports.FlatStar = exports.SvgWrapper(paths.SvgFlatStar);
exports.Flatbed = exports.SvgWrapper(paths.SvgFlatbed);
exports.FlatbedCovered = exports.SvgWrapper(paths.SvgFlatbedCovered);
exports.FleshyMass = exports.SvgWrapper(paths.SvgFleshyMass);
exports.FlexibleStar = exports.SvgWrapper(paths.SvgFlexibleStar);
exports.FloatingCrystal = exports.SvgWrapper(paths.SvgFloatingCrystal);
exports.FlowerPot = exports.SvgWrapper(paths.SvgFlowerPot);
exports.FlowerTwirl = exports.SvgWrapper(paths.SvgFlowerTwirl);
exports.Flowers = exports.SvgWrapper(paths.SvgFlowers);
exports.FluffyCloud = exports.SvgWrapper(paths.SvgFluffyCloud);
exports.FluffyFlame = exports.SvgWrapper(paths.SvgFluffyFlame);
exports.FluffySwirl = exports.SvgWrapper(paths.SvgFluffySwirl);
exports.FluffyTrefoil = exports.SvgWrapper(paths.SvgFluffyTrefoil);
exports.FluffyWing = exports.SvgWrapper(paths.SvgFluffyWing);
exports.FlyingDagger = exports.SvgWrapper(paths.SvgFlyingDagger);
exports.FlyingFlag = exports.SvgWrapper(paths.SvgFlyingFlag);
exports.FlyingShuriken = exports.SvgWrapper(paths.SvgFlyingShuriken);
exports.FlyingTrout = exports.SvgWrapper(paths.SvgFlyingTrout);
exports.FnFal = exports.SvgWrapper(paths.SvgFnFal);
exports.Foam = exports.SvgWrapper(paths.SvgFoam);
exports.FoamyDisc = exports.SvgWrapper(paths.SvgFoamyDisc);
exports.FocusedLightning = exports.SvgWrapper(paths.SvgFocusedLightning);
exports.FoldedPaper = exports.SvgWrapper(paths.SvgFoldedPaper);
exports.Fomorian = exports.SvgWrapper(paths.SvgFomorian);
exports.FoodChain = exports.SvgWrapper(paths.SvgFoodChain);
exports.FootTrip = exports.SvgWrapper(paths.SvgFootTrip);
exports.Footprint = exports.SvgWrapper(paths.SvgFootprint);
exports.Footsteps = exports.SvgWrapper(paths.SvgFootsteps);
exports.ForwardField = exports.SvgWrapper(paths.SvgForwardField);
exports.ForwardSun = exports.SvgWrapper(paths.SvgForwardSun);
exports.Fossil = exports.SvgWrapper(paths.SvgFossil);
exports.Fountain = exports.SvgWrapper(paths.SvgFountain);
exports.FountainPen = exports.SvgWrapper(paths.SvgFountainPen);
exports.FoxHead = exports.SvgWrapper(paths.SvgFoxHead);
exports.FragmentedMeteor = exports.SvgWrapper(paths.SvgFragmentedMeteor);
exports.FragmentedSword = exports.SvgWrapper(paths.SvgFragmentedSword);
exports.Fragrance = exports.SvgWrapper(paths.SvgFragrance);
exports.FrankensteinCreature = exports.SvgWrapper(paths.SvgFrankensteinCreature);
exports.FrayedArrow = exports.SvgWrapper(paths.SvgFrayedArrow);
exports.FreedomDove = exports.SvgWrapper(paths.SvgFreedomDove);
exports.FriedFish = exports.SvgWrapper(paths.SvgFriedFish);
exports.Frog = exports.SvgWrapper(paths.SvgFrog);
exports.FrontTeeth = exports.SvgWrapper(paths.SvgFrontTeeth);
exports.FrontalLobe = exports.SvgWrapper(paths.SvgFrontalLobe);
exports.Frostfire = exports.SvgWrapper(paths.SvgFrostfire);
exports.FrozenArrow = exports.SvgWrapper(paths.SvgFrozenArrow);
exports.FrozenBlock = exports.SvgWrapper(paths.SvgFrozenBlock);
exports.FrozenOrb = exports.SvgWrapper(paths.SvgFrozenOrb);
exports.FruitBowl = exports.SvgWrapper(paths.SvgFruitBowl);
exports.Fruiting = exports.SvgWrapper(paths.SvgFruiting);
exports.FulguroPunch = exports.SvgWrapper(paths.SvgFulguroPunch);
exports.Galleon = exports.SvgWrapper(paths.SvgGalleon);
exports.GamepadCross = exports.SvgWrapper(paths.SvgGamepadCross);
exports.GasMask = exports.SvgWrapper(paths.SvgGasMask);
exports.Gavel = exports.SvgWrapper(paths.SvgGavel);
exports.Gaze = exports.SvgWrapper(paths.SvgGaze);
exports.GearHammer = exports.SvgWrapper(paths.SvgGearHammer);
exports.Gears = exports.SvgWrapper(paths.SvgGears);
exports.Gecko = exports.SvgWrapper(paths.SvgGecko);
exports.GemChain = exports.SvgWrapper(paths.SvgGemChain);
exports.GemNecklace = exports.SvgWrapper(paths.SvgGemNecklace);
exports.GemPendant = exports.SvgWrapper(paths.SvgGemPendant);
exports.Gems = exports.SvgWrapper(paths.SvgGems);
exports.Ghost = exports.SvgWrapper(paths.SvgGhost);
exports.GhostAlly = exports.SvgWrapper(paths.SvgGhostAlly);
exports.Gibbet = exports.SvgWrapper(paths.SvgGibbet);
exports.GiftOfKnowledge = exports.SvgWrapper(paths.SvgGiftOfKnowledge);
exports.GiftTrap = exports.SvgWrapper(paths.SvgGiftTrap);
exports.Gladius = exports.SvgWrapper(paths.SvgGladius);
exports.GlassHeart = exports.SvgWrapper(paths.SvgGlassHeart);
exports.GlassShot = exports.SvgWrapper(paths.SvgGlassShot);
exports.Glider = exports.SvgWrapper(paths.SvgGlider);
exports.Globe = exports.SvgWrapper(paths.SvgGlobe);
exports.Glock = exports.SvgWrapper(paths.SvgGlock);
exports.Gloop = exports.SvgWrapper(paths.SvgGloop);
exports.GlowingHands = exports.SvgWrapper(paths.SvgGlowingHands);
exports.GluttonousSmile = exports.SvgWrapper(paths.SvgGluttonousSmile);
exports.Gluttony = exports.SvgWrapper(paths.SvgGluttony);
exports.Goat = exports.SvgWrapper(paths.SvgGoat);
exports.GoldBar = exports.SvgWrapper(paths.SvgGoldBar);
exports.GoldScarab = exports.SvgWrapper(paths.SvgGoldScarab);
exports.GoldShell = exports.SvgWrapper(paths.SvgGoldShell);
exports.GooExplosion = exports.SvgWrapper(paths.SvgGooExplosion);
exports.GooSkull = exports.SvgWrapper(paths.SvgGooSkull);
exports.GooSpurt = exports.SvgWrapper(paths.SvgGooSpurt);
exports.GooeyDaemon = exports.SvgWrapper(paths.SvgGooeyDaemon);
exports.GooeyEyedSun = exports.SvgWrapper(paths.SvgGooeyEyedSun);
exports.GooeyImpact = exports.SvgWrapper(paths.SvgGooeyImpact);
exports.GooeyMolecule = exports.SvgWrapper(paths.SvgGooeyMolecule);
exports.GooeySword = exports.SvgWrapper(paths.SvgGooeySword);
exports.GothicCross = exports.SvgWrapper(paths.SvgGothicCross);
exports.Grab = exports.SvgWrapper(paths.SvgGrab);
exports.Grapes = exports.SvgWrapper(paths.SvgGrapes);
exports.Grapple = exports.SvgWrapper(paths.SvgGrapple);
exports.GraspingClaws = exports.SvgWrapper(paths.SvgGraspingClaws);
exports.GreaseTrap = exports.SvgWrapper(paths.SvgGreaseTrap);
exports.GreatWarTank = exports.SvgWrapper(paths.SvgGreatWarTank);
exports.Grenade = exports.SvgWrapper(paths.SvgGrenade);
exports.GrimReaper = exports.SvgWrapper(paths.SvgGrimReaper);
exports.GroundSprout = exports.SvgWrapper(paths.SvgGroundSprout);
exports.Groundbreaker = exports.SvgWrapper(paths.SvgGroundbreaker);
exports.GroupedDrops = exports.SvgWrapper(paths.SvgGroupedDrops);
exports.GuardedTower = exports.SvgWrapper(paths.SvgGuardedTower);
exports.Guillotine = exports.SvgWrapper(paths.SvgGuillotine);
exports.Guitar = exports.SvgWrapper(paths.SvgGuitar);
exports.Gunshot = exports.SvgWrapper(paths.SvgGunshot);
exports.Halberd = exports.SvgWrapper(paths.SvgHalberd);
exports.HalberdShuriken = exports.SvgWrapper(paths.SvgHalberdShuriken);
exports.HalfHeart = exports.SvgWrapper(paths.SvgHalfHeart);
exports.HalfTornado = exports.SvgWrapper(paths.SvgHalfTornado);
exports.Halt = exports.SvgWrapper(paths.SvgHalt);
exports.HamShank = exports.SvgWrapper(paths.SvgHamShank);
exports.HammerDrop = exports.SvgWrapper(paths.SvgHammerDrop);
exports.HammerNails = exports.SvgWrapper(paths.SvgHammerNails);
exports.Hand = exports.SvgWrapper(paths.SvgHand);
exports.Handcuffs = exports.SvgWrapper(paths.SvgHandcuffs);
exports.HangGlider = exports.SvgWrapper(paths.SvgHangGlider);
exports.HangingSpider = exports.SvgWrapper(paths.SvgHangingSpider);
exports.HappySkull = exports.SvgWrapper(paths.SvgHappySkull);
exports.HarpoonChain = exports.SvgWrapper(paths.SvgHarpoonChain);
exports.HarpoonTrident = exports.SvgWrapper(paths.SvgHarpoonTrident);
exports.Harpy = exports.SvgWrapper(paths.SvgHarpy);
exports.HarryPotterSkull = exports.SvgWrapper(paths.SvgHarryPotterSkull);
exports.HastyGrave = exports.SvgWrapper(paths.SvgHastyGrave);
exports.Hatchets = exports.SvgWrapper(paths.SvgHatchets);
exports.Haunting = exports.SvgWrapper(paths.SvgHaunting);
exports.HawkEmblem = exports.SvgWrapper(paths.SvgHawkEmblem);
exports.HazardSign = exports.SvgWrapper(paths.SvgHazardSign);
exports.Headshot = exports.SvgWrapper(paths.SvgHeadShot);
exports.HealthDecrease = exports.SvgWrapper(paths.SvgHealthDecrease);
exports.HealthIncrease = exports.SvgWrapper(paths.SvgHealthIncrease);
exports.HealthNormal = exports.SvgWrapper(paths.SvgHealthNormal);
exports.HearingDisabled = exports.SvgWrapper(paths.SvgHearingDisabled);
exports.HeartBottle = exports.SvgWrapper(paths.SvgHeartBottle);
exports.HeartDrop = exports.SvgWrapper(paths.SvgHeartDrop);
exports.HeartInside = exports.SvgWrapper(paths.SvgHeartInside);
exports.HeartMinus = exports.SvgWrapper(paths.SvgHeartMinus);
exports.HeartOrgan = exports.SvgWrapper(paths.SvgHeartOrgan);
exports.HeartPlus = exports.SvgWrapper(paths.SvgHeartPlus);
exports.HeartTower = exports.SvgWrapper(paths.SvgHeartTower);
exports.Heartburn = exports.SvgWrapper(paths.SvgHeartburn);
exports.Hearts = exports.SvgWrapper(paths.SvgHearts);
exports.HeatHaze = exports.SvgWrapper(paths.SvgHeatHaze);
exports.HeavyArrow = exports.SvgWrapper(paths.SvgHeavyArrow);
exports.HeavyFall = exports.SvgWrapper(paths.SvgHeavyFall);
exports.HeavyFighter = exports.SvgWrapper(paths.SvgHeavyFighter);
exports.HeavyHelm = exports.SvgWrapper(paths.SvgHeavyHelm);
exports.HeavyLightning = exports.SvgWrapper(paths.SvgHeavyLightning);
exports.HeavyRain = exports.SvgWrapper(paths.SvgHeavyRain);
exports.HeavyThornyTriskelion = exports.SvgWrapper(paths.SvgHeavyThornyTriskelion);
exports.HeavyTimer = exports.SvgWrapper(paths.SvgHeavyTimer);
exports.Helmet = exports.SvgWrapper(paths.SvgHelmet);
exports.HelmetHeadShot = exports.SvgWrapper(paths.SvgHelmetHeadShot);
exports.Help = exports.SvgWrapper(paths.SvgHelp);
exports.Hexes = exports.SvgWrapper(paths.SvgHexes);
exports.Hidden = exports.SvgWrapper(paths.SvgHidden);
exports.HighFive = exports.SvgWrapper(paths.SvgHighFive);
exports.HighShot = exports.SvgWrapper(paths.SvgHighShot);
exports.Hive = exports.SvgWrapper(paths.SvgHive);
exports.HollowCat = exports.SvgWrapper(paths.SvgHollowCat);
exports.Holosphere = exports.SvgWrapper(paths.SvgHolosphere);
exports.HolyGrail = exports.SvgWrapper(paths.SvgHolyGrail);
exports.HolyOak = exports.SvgWrapper(paths.SvgHolyOak);
exports.HolySymbol = exports.SvgWrapper(paths.SvgHolySymbol);
exports.Honeycomb = exports.SvgWrapper(paths.SvgHoneycomb);
exports.Honeypot = exports.SvgWrapper(paths.SvgHoneypot);
exports.Hood = exports.SvgWrapper(paths.SvgHood);
exports.HoodedAssassin = exports.SvgWrapper(paths.SvgHoodedAssassin);
exports.HoodedFigure = exports.SvgWrapper(paths.SvgHoodedFigure);
exports.Hoof = exports.SvgWrapper(paths.SvgHoof);
exports.HornInternal = exports.SvgWrapper(paths.SvgHornInternal);
exports.HornedHelm = exports.SvgWrapper(paths.SvgHornedHelm);
exports.HornedSkull = exports.SvgWrapper(paths.SvgHornedSkull);
exports.HorseHead = exports.SvgWrapper(paths.SvgHorseHead);
exports.HospitalCross = exports.SvgWrapper(paths.SvgHospitalCross);
exports.HotSpices = exports.SvgWrapper(paths.SvgHotSpices);
exports.HotSurface = exports.SvgWrapper(paths.SvgHotSurface);
exports.Hound = exports.SvgWrapper(paths.SvgHound);
exports.Hourglass = exports.SvgWrapper(paths.SvgHourglass);
exports.HuntingHorn = exports.SvgWrapper(paths.SvgHuntingHorn);
exports.Hydra = exports.SvgWrapper(paths.SvgHydra);
exports.HydraShot = exports.SvgWrapper(paths.SvgHydraShot);
exports.HypersonicBolt = exports.SvgWrapper(paths.SvgHypersonicBolt);
exports.HypersonicMelon = exports.SvgWrapper(paths.SvgHypersonicMelon);
exports.HypodermicTest = exports.SvgWrapper(paths.SvgHypodermicTest);
exports.IceBolt = exports.SvgWrapper(paths.SvgIceBolt);
exports.IceBomb = exports.SvgWrapper(paths.SvgIceBomb);
exports.IceCube = exports.SvgWrapper(paths.SvgIceCube);
exports.IceShield = exports.SvgWrapper(paths.SvgIceShield);
exports.IceSpear = exports.SvgWrapper(paths.SvgIceSpear);
exports.Icebergs = exports.SvgWrapper(paths.SvgIcebergs);
exports.IciclesAura = exports.SvgWrapper(paths.SvgIciclesAura);
exports.IciclesFence = exports.SvgWrapper(paths.SvgIciclesFence);
exports.Ifrit = exports.SvgWrapper(paths.SvgIfrit);
exports.ImbricatedArrows = exports.SvgWrapper(paths.SvgImbricatedArrows);
exports.Imp = exports.SvgWrapper(paths.SvgImp);
exports.ImpLaugh = exports.SvgWrapper(paths.SvgImpLaugh);
exports.ImpactPoint = exports.SvgWrapper(paths.SvgImpactPoint);
exports.Implosion = exports.SvgWrapper(paths.SvgImplosion);
exports.Imprisoned = exports.SvgWrapper(paths.SvgImprisoned);
exports.Incense = exports.SvgWrapper(paths.SvgIncense);
exports.Incisors = exports.SvgWrapper(paths.SvgIncisors);
exports.IncomingRocket = exports.SvgWrapper(paths.SvgIncomingRocket);
exports.InfestedMass = exports.SvgWrapper(paths.SvgInfestedMass);
exports.Infinity = exports.SvgWrapper(paths.SvgInfinity);
exports.InkSwirl = exports.SvgWrapper(paths.SvgInkSwirl);
exports.InnerSelf = exports.SvgWrapper(paths.SvgInnerSelf);
exports.InsectJaws = exports.SvgWrapper(paths.SvgInsectJaws);
exports.Interdiction = exports.SvgWrapper(paths.SvgInterdiction);
exports.InterlacedTentacles = exports.SvgWrapper(paths.SvgInterlacedTentacles);
exports.InterleavedArrows = exports.SvgWrapper(paths.SvgInterleavedArrows);
exports.InterleavedClaws = exports.SvgWrapper(paths.SvgInterleavedClaws);
exports.InternalInjury = exports.SvgWrapper(paths.SvgInternalInjury);
exports.InternalOrgan = exports.SvgWrapper(paths.SvgInternalOrgan);
exports.InterstellarPath = exports.SvgWrapper(paths.SvgInterstellarPath);
exports.InvertedDice1 = exports.SvgWrapper(paths.SvgInvertedDice1);
exports.InvertedDice2 = exports.SvgWrapper(paths.SvgInvertedDice2);
exports.InvertedDice3 = exports.SvgWrapper(paths.SvgInvertedDice3);
exports.InvertedDice4 = exports.SvgWrapper(paths.SvgInvertedDice4);
exports.InvertedDice5 = exports.SvgWrapper(paths.SvgInvertedDice5);
exports.InvertedDice6 = exports.SvgWrapper(paths.SvgInvertedDice6);
exports.IonCannonBlast = exports.SvgWrapper(paths.SvgIonCannonBlast);
exports.IronCross = exports.SvgWrapper(paths.SvgIronCross);
exports.IronHulledWarship = exports.SvgWrapper(paths.SvgIronHulledWarship);
exports.IronMask = exports.SvgWrapper(paths.SvgIronMask);
exports.JamesBondAperture = exports.SvgWrapper(paths.SvgJamesBondAperture);
exports.Jawbone = exports.SvgWrapper(paths.SvgJawbone);
exports.Jeep = exports.SvgWrapper(paths.SvgJeep);
exports.Jellyfish = exports.SvgWrapper(paths.SvgJellyfish);
exports.Jetpack = exports.SvgWrapper(paths.SvgJetPack);
exports.JeweledChalice = exports.SvgWrapper(paths.SvgJeweledChalice);
exports.JigsawBox = exports.SvgWrapper(paths.SvgJigsawBox);
exports.JigsawPiece = exports.SvgWrapper(paths.SvgJigsawPiece);
exports.Joint = exports.SvgWrapper(paths.SvgJoint);
exports.Journey = exports.SvgWrapper(paths.SvgJourney);
exports.Juggler = exports.SvgWrapper(paths.SvgJuggler);
exports.JusticeStar = exports.SvgWrapper(paths.SvgJusticeStar);
exports.KaleidoscopePearls = exports.SvgWrapper(paths.SvgKaleidoscopePearls);
exports.Kevlar = exports.SvgWrapper(paths.SvgKevlar);
exports.KevlarVest = exports.SvgWrapper(paths.SvgKevlarVest);
exports.Key = exports.SvgWrapper(paths.SvgKey);
exports.Kindle = exports.SvgWrapper(paths.SvgKindle);
exports.King = exports.SvgWrapper(paths.SvgKing);
exports.KitchenKnives = exports.SvgWrapper(paths.SvgKitchenKnives);
exports.Knapsack = exports.SvgWrapper(paths.SvgKnapsack);
exports.KnifeFork = exports.SvgWrapper(paths.SvgKnifeFork);
exports.KnifeThrust = exports.SvgWrapper(paths.SvgKnifeThrust);
exports.Knockout = exports.SvgWrapper(paths.SvgKnockout);
exports.Kusarigama = exports.SvgWrapper(paths.SvgKusarigama);
exports.Lamellar = exports.SvgWrapper(paths.SvgLamellar);
exports.LampreyMouth = exports.SvgWrapper(paths.SvgLampreyMouth);
exports.LandMine = exports.SvgWrapper(paths.SvgLandMine);
exports.Lantern = exports.SvgWrapper(paths.SvgLantern);
exports.LanternFlame = exports.SvgWrapper(paths.SvgLanternFlame);
exports.LargeWound = exports.SvgWrapper(paths.SvgLargeWound);
exports.LaserBlast = exports.SvgWrapper(paths.SvgLaserBlast);
exports.LaserBurst = exports.SvgWrapper(paths.SvgLaserBurst);
exports.LaserGun = exports.SvgWrapper(paths.SvgLaserGun);
exports.LaserPrecision = exports.SvgWrapper(paths.SvgLaserPrecision);
exports.LaserSparks = exports.SvgWrapper(paths.SvgLaserSparks);
exports.LaserWarning = exports.SvgWrapper(paths.SvgLaserWarning);
exports.Laserburn = exports.SvgWrapper(paths.SvgLaserburn);
exports.LaurelCrown = exports.SvgWrapper(paths.SvgLaurelCrown);
exports.Laurels = exports.SvgWrapper(paths.SvgLaurels);
exports.Lava = exports.SvgWrapper(paths.SvgLava);
exports.LawStar = exports.SvgWrapper(paths.SvgLawStar);
exports.LayeredArmor = exports.SvgWrapper(paths.SvgLayeredArmor);
exports.LeafSkeleton = exports.SvgWrapper(paths.SvgLeafSkeleton);
exports.LeafSwirl = exports.SvgWrapper(paths.SvgLeafSwirl);
exports.LeakySkull = exports.SvgWrapper(paths.SvgLeakySkull);
exports.LeatherBoot = exports.SvgWrapper(paths.SvgLeatherBoot);
exports.LeatherVest = exports.SvgWrapper(paths.SvgLeatherVest);
exports.LeeEnfield = exports.SvgWrapper(paths.SvgLeeEnfield);
exports.LeechingWorm = exports.SvgWrapper(paths.SvgLeechingWorm);
exports.LetterBomb = exports.SvgWrapper(paths.SvgLetterBomb);
exports.LevelFour = exports.SvgWrapper(paths.SvgLevelFour);
exports.LevelFourAdvanced = exports.SvgWrapper(paths.SvgLevelFourAdvanced);
exports.LevelThree = exports.SvgWrapper(paths.SvgLevelThree);
exports.LevelThreeAdvanced = exports.SvgWrapper(paths.SvgLevelThreeAdvanced);
exports.LevelTwo = exports.SvgWrapper(paths.SvgLevelTwo);
exports.LevelTwoAdvanced = exports.SvgWrapper(paths.SvgLevelTwoAdvanced);
exports.Lever = exports.SvgWrapper(paths.SvgLever);
exports.LifeInTheBalance = exports.SvgWrapper(paths.SvgLifeInTheBalance);
exports.LifeSupport = exports.SvgWrapper(paths.SvgLifeSupport);
exports.LifeTap = exports.SvgWrapper(paths.SvgLifeTap);
exports.Lift = exports.SvgWrapper(paths.SvgLift);
exports.LightBulb = exports.SvgWrapper(paths.SvgLightBulb);
exports.LightFighter = exports.SvgWrapper(paths.SvgLightFighter);
exports.LightThornyTriskelion = exports.SvgWrapper(paths.SvgLightThornyTriskelion);
exports.LightningArc = exports.SvgWrapper(paths.SvgLightningArc);
exports.LightningBow = exports.SvgWrapper(paths.SvgLightningBow);
exports.LightningBranches = exports.SvgWrapper(paths.SvgLightningBranches);
exports.LightningDissipation = exports.SvgWrapper(paths.SvgLightningDissipation);
exports.LightningElectron = exports.SvgWrapper(paths.SvgLightningElectron);
exports.LightningFrequency = exports.SvgWrapper(paths.SvgLightningFrequency);
exports.LightningHelix = exports.SvgWrapper(paths.SvgLightningHelix);
exports.LightningMask = exports.SvgWrapper(paths.SvgLightningMask);
exports.LightningSaber = exports.SvgWrapper(paths.SvgLightningSaber);
exports.LightningShadow = exports.SvgWrapper(paths.SvgLightningShadow);
exports.LightningShield = exports.SvgWrapper(paths.SvgLightningShield);
exports.LightningShout = exports.SvgWrapper(paths.SvgLightningShout);
exports.LightningSlashes = exports.SvgWrapper(paths.SvgLightningSlashes);
exports.LightningSpanner = exports.SvgWrapper(paths.SvgLightningSpanner);
exports.LightningStorm = exports.SvgWrapper(paths.SvgLightningStorm);
exports.LightningTear = exports.SvgWrapper(paths.SvgLightningTear);
exports.LightningTree = exports.SvgWrapper(paths.SvgLightningTree);
exports.LightningTrio = exports.SvgWrapper(paths.SvgLightningTrio);
exports.LindenLeaf = exports.SvgWrapper(paths.SvgLindenLeaf);
exports.LinkedRings = exports.SvgWrapper(paths.SvgLinkedRings);
exports.Lion = exports.SvgWrapper(paths.SvgLion);
exports.Lips = exports.SvgWrapper(paths.SvgLips);
exports.LitCandelabra = exports.SvgWrapper(paths.SvgLitCandelabra);
exports.LizardTongue = exports.SvgWrapper(paths.SvgLizardTongue);
exports.Lizardman = exports.SvgWrapper(paths.SvgLizardman);
exports.LobArrow = exports.SvgWrapper(paths.SvgLobArrow);
exports.LockedChest = exports.SvgWrapper(paths.SvgLockedChest);
exports.LockedFortress = exports.SvgWrapper(paths.SvgLockedFortress);
exports.Logging = exports.SvgWrapper(paths.SvgLogging);
exports.LongAntennaeBug = exports.SvgWrapper(paths.SvgLongAntennaeBug);
exports.LongLeggedSpider = exports.SvgWrapper(paths.SvgLongLeggedSpider);
exports.LostLimb = exports.SvgWrapper(paths.SvgLostLimb);
exports.Lotus = exports.SvgWrapper(paths.SvgLotus);
exports.LotusFlower = exports.SvgWrapper(paths.SvgLotusFlower);
exports.LoveHowl = exports.SvgWrapper(paths.SvgLoveHowl);
exports.LoveInjection = exports.SvgWrapper(paths.SvgLoveInjection);
exports.LoveSong = exports.SvgWrapper(paths.SvgLoveSong);
exports.LuciferCannon = exports.SvgWrapper(paths.SvgLuciferCannon);
exports.Luger = exports.SvgWrapper(paths.SvgLuger);
exports.Lyre = exports.SvgWrapper(paths.SvgLyre);
exports.M3GreaseGun = exports.SvgWrapper(paths.SvgM3GreaseGun);
exports.Mac10 = exports.SvgWrapper(paths.SvgMac10);
exports.MaceHead = exports.SvgWrapper(paths.SvgMaceHead);
exports.Machete = exports.SvgWrapper(paths.SvgMachete);
exports.MachineGun = exports.SvgWrapper(paths.SvgMachineGun);
exports.MadScientist = exports.SvgWrapper(paths.SvgMadScientist);
exports.Maggot = exports.SvgWrapper(paths.SvgMaggot);
exports.MagicGate = exports.SvgWrapper(paths.SvgMagicGate);
exports.MagicLamp = exports.SvgWrapper(paths.SvgMagicLamp);
exports.MagicPalm = exports.SvgWrapper(paths.SvgMagicPalm);
exports.MagicPortal = exports.SvgWrapper(paths.SvgMagicPortal);
exports.MagicShield = exports.SvgWrapper(paths.SvgMagicShield);
exports.MagicSwirl = exports.SvgWrapper(paths.SvgMagicSwirl);
exports.Magnet = exports.SvgWrapper(paths.SvgMagnet);
exports.MagnetBlast = exports.SvgWrapper(paths.SvgMagnetBlast);
exports.MagnifyingGlass = exports.SvgWrapper(paths.SvgMagnifyingGlass);
exports.MailShirt = exports.SvgWrapper(paths.SvgMailShirt);
exports.MailedFist = exports.SvgWrapper(paths.SvgMailedFist);
exports.Manacles = exports.SvgWrapper(paths.SvgManacles);
exports.Mantrap = exports.SvgWrapper(paths.SvgMantrap);
exports.MapleLeaf = exports.SvgWrapper(paths.SvgMapleLeaf);
exports.MarrowDrain = exports.SvgWrapper(paths.SvgMarrowDrain);
exports.Martini = exports.SvgWrapper(paths.SvgMartini);
exports.MaskedSpider = exports.SvgWrapper(paths.SvgMaskedSpider);
exports.MassDriver = exports.SvgWrapper(paths.SvgMassDriver);
exports.MasterOfArms = exports.SvgWrapper(paths.SvgMasterOfArms);
exports.MatchHead = exports.SvgWrapper(paths.SvgMatchHead);
exports.MatchTip = exports.SvgWrapper(paths.SvgMatchTip);
exports.MaterialsScience = exports.SvgWrapper(paths.SvgMaterialsScience);
exports.Maze = exports.SvgWrapper(paths.SvgMaze);
exports.MazeCornea = exports.SvgWrapper(paths.SvgMazeCornea);
exports.MazeSaw = exports.SvgWrapper(paths.SvgMazeSaw);
exports.Meat = exports.SvgWrapper(paths.SvgMeat);
exports.MeatCleaver = exports.SvgWrapper(paths.SvgMeatCleaver);
exports.MeatHook = exports.SvgWrapper(paths.SvgMeatHook);
exports.MechanicalArm = exports.SvgWrapper(paths.SvgMechanicalArm);
exports.Medal = exports.SvgWrapper(paths.SvgMedal);
exports.MedalSkull = exports.SvgWrapper(paths.SvgMedalSkull);
exports.MedicalPack = exports.SvgWrapper(paths.SvgMedicalPack);
exports.MedicalPackAlt = exports.SvgWrapper(paths.SvgMedicalPackAlt);
exports.Meditation = exports.SvgWrapper(paths.SvgMeditation);
exports.MedusaHead = exports.SvgWrapper(paths.SvgMedusaHead);
exports.Megabot = exports.SvgWrapper(paths.SvgMegabot);
exports.MeshBall = exports.SvgWrapper(paths.SvgMeshBall);
exports.MetalBar = exports.SvgWrapper(paths.SvgMetalBar);
exports.MetalDisc = exports.SvgWrapper(paths.SvgMetalDisc);
exports.MetalHand = exports.SvgWrapper(paths.SvgMetalHand);
exports.MetalScales = exports.SvgWrapper(paths.SvgMetalScales);
exports.MeteorImpact = exports.SvgWrapper(paths.SvgMeteorImpact);
exports.Microchip = exports.SvgWrapper(paths.SvgMicrochip);
exports.Microscope = exports.SvgWrapper(paths.SvgMicroscope);
exports.MicroscopeLens = exports.SvgWrapper(paths.SvgMicroscopeLens);
exports.MiddleArrow = exports.SvgWrapper(paths.SvgMiddleArrow);
exports.MidnightClaw = exports.SvgWrapper(paths.SvgMidnightClaw);
exports.MightySpanner = exports.SvgWrapper(paths.SvgMightySpanner);
exports.MilitaryAmbulance = exports.SvgWrapper(paths.SvgMilitaryAmbulance);
exports.MilkCarton = exports.SvgWrapper(paths.SvgMilkCarton);
exports.MineExplosion = exports.SvgWrapper(paths.SvgMineExplosion);
exports.Minefield = exports.SvgWrapper(paths.SvgMinefield);
exports.MineralHeart = exports.SvgWrapper(paths.SvgMineralHeart);
exports.Minerals = exports.SvgWrapper(paths.SvgMinerals);
exports.Minigun = exports.SvgWrapper(paths.SvgMinigun);
exports.Mining = exports.SvgWrapper(paths.SvgMining);
exports.Minions = exports.SvgWrapper(paths.SvgMinions);
exports.Minotaur = exports.SvgWrapper(paths.SvgMinotaur);
exports.MiracleMedecine = exports.SvgWrapper(paths.SvgMiracleMedecine);
exports.MirrorMirror = exports.SvgWrapper(paths.SvgMirrorMirror);
exports.MissileMech = exports.SvgWrapper(paths.SvgMissileMech);
exports.MissilePod = exports.SvgWrapper(paths.SvgMissilePod);
exports.MissileSwarm = exports.SvgWrapper(paths.SvgMissileSwarm);
exports.Mite = exports.SvgWrapper(paths.SvgMite);
exports.MiteAlt = exports.SvgWrapper(paths.SvgMiteAlt);
exports.MoebiusStar = exports.SvgWrapper(paths.SvgMoebiusStar);
exports.MoebiusTrefoil = exports.SvgWrapper(paths.SvgMoebiusTrefoil);
exports.MoebiusTriangle = exports.SvgWrapper(paths.SvgMoebiusTriangle);
exports.Molecule = exports.SvgWrapper(paths.SvgMolecule);
exports.Molotov = exports.SvgWrapper(paths.SvgMolotov);
exports.Monkey = exports.SvgWrapper(paths.SvgMonkey);
exports.MonsterGrasp = exports.SvgWrapper(paths.SvgMonsterGrasp);
exports.Moon = exports.SvgWrapper(paths.SvgMoon);
exports.MoonClaws = exports.SvgWrapper(paths.SvgMoonClaws);
exports.MorbidHumour = exports.SvgWrapper(paths.SvgMorbidHumour);
exports.Mountains = exports.SvgWrapper(paths.SvgMountains);
exports.Mountaintop = exports.SvgWrapper(paths.SvgMountaintop);
exports.MountedKnight = exports.SvgWrapper(paths.SvgMountedKnight);
exports.Mouse = exports.SvgWrapper(paths.SvgMouse);
exports.MouthWatering = exports.SvgWrapper(paths.SvgMouthWatering);
exports.MovementSensor = exports.SvgWrapper(paths.SvgMovementSensor);
exports.Mp40 = exports.SvgWrapper(paths.SvgMp40);
exports.Mp5 = exports.SvgWrapper(paths.SvgMp5);
exports.Mp5K = exports.SvgWrapper(paths.SvgMp5K);
exports.MucousPillar = exports.SvgWrapper(paths.SvgMucousPillar);
exports.MuscleFat = exports.SvgWrapper(paths.SvgMuscleFat);
exports.MuscleUp = exports.SvgWrapper(paths.SvgMuscleUp);
exports.Mushroom = exports.SvgWrapper(paths.SvgMushroom);
exports.MushroomCloud = exports.SvgWrapper(paths.SvgMushroomCloud);
exports.MushroomGills = exports.SvgWrapper(paths.SvgMushroomGills);
exports.MusicSpell = exports.SvgWrapper(paths.SvgMusicSpell);
exports.Musket = exports.SvgWrapper(paths.SvgMusket);
exports.NailedFoot = exports.SvgWrapper(paths.SvgNailedFoot);
exports.NailedHead = exports.SvgWrapper(paths.SvgNailedHead);
exports.Nails = exports.SvgWrapper(paths.SvgNails);
exports.NautilusShell = exports.SvgWrapper(paths.SvgNautilusShell);
exports.Necklace = exports.SvgWrapper(paths.SvgNecklace);
exports.NeedleDrill = exports.SvgWrapper(paths.SvgNeedleDrill);
exports.NeedleJaws = exports.SvgWrapper(paths.SvgNeedleJaws);
exports.NestedEclipses = exports.SvgWrapper(paths.SvgNestedEclipses);
exports.NewShoot = exports.SvgWrapper(paths.SvgNewShoot);
exports.NightSky = exports.SvgWrapper(paths.SvgNightSky);
exports.NinjaHead = exports.SvgWrapper(paths.SvgNinjaHead);
exports.NinjaHeroicStance = exports.SvgWrapper(paths.SvgNinjaHeroicStance);
exports.NinjaMask = exports.SvgWrapper(paths.SvgNinjaMask);
exports.NinjaStar = exports.SvgWrapper(paths.SvgNinjaStar);
exports.Nodular = exports.SvgWrapper(paths.SvgNodular);
exports.NoodleBall = exports.SvgWrapper(paths.SvgNoodleBall);
exports.NorthStarShuriken = exports.SvgWrapper(paths.SvgNorthStarShuriken);
exports.NothingToSay = exports.SvgWrapper(paths.SvgNothingToSay);
exports.Nuclear = exports.SvgWrapper(paths.SvgNuclear);
exports.NuclearBomb = exports.SvgWrapper(paths.SvgNuclearBomb);
exports.NunFace = exports.SvgWrapper(paths.SvgNunFace);
exports.Oak = exports.SvgWrapper(paths.SvgOak);
exports.Oat = exports.SvgWrapper(paths.SvgOat);
exports.Occupy = exports.SvgWrapper(paths.SvgOccupy);
exports.OctogonalEye = exports.SvgWrapper(paths.SvgOctogonalEye);
exports.Octoman = exports.SvgWrapper(paths.SvgOctoman);
exports.Octopus = exports.SvgWrapper(paths.SvgOctopus);
exports.OilDrum = exports.SvgWrapper(paths.SvgOilDrum);
exports.OilySpiral = exports.SvgWrapper(paths.SvgOilySpiral);
exports.OldKing = exports.SvgWrapper(paths.SvgOldKing);
exports.Omega = exports.SvgWrapper(paths.SvgOmega);
exports.OnSight = exports.SvgWrapper(paths.SvgOnSight);
exports.OnTarget = exports.SvgWrapper(paths.SvgOnTarget);
exports.OneEyed = exports.SvgWrapper(paths.SvgOneEyed);
exports.OpenBook = exports.SvgWrapper(paths.SvgOpenBook);
exports.OpenChest = exports.SvgWrapper(paths.SvgOpenChest);
exports.OpenPalm = exports.SvgWrapper(paths.SvgOpenPalm);
exports.OpenTreasureChest = exports.SvgWrapper(paths.SvgOpenTreasureChest);
exports.OpenWound = exports.SvgWrapper(paths.SvgOpenWound);
exports.OpeningShell = exports.SvgWrapper(paths.SvgOpeningShell);
exports.Oppidum = exports.SvgWrapper(paths.SvgOppidum);
exports.Oppression = exports.SvgWrapper(paths.SvgOppression);
exports.OrbDirection = exports.SvgWrapper(paths.SvgOrbDirection);
exports.OrbWand = exports.SvgWrapper(paths.SvgOrbWand);
exports.Orbit = exports.SvgWrapper(paths.SvgOrbit);
exports.Orbital = exports.SvgWrapper(paths.SvgOrbital);
exports.OrbitalRays = exports.SvgWrapper(paths.SvgOrbitalRays);
exports.Ore = exports.SvgWrapper(paths.SvgOre);
exports.Ouroboros = exports.SvgWrapper(paths.SvgOuroboros);
exports.OverInfinity = exports.SvgWrapper(paths.SvgOverInfinity);
exports.Overdose = exports.SvgWrapper(paths.SvgOverdose);
exports.Overdrive = exports.SvgWrapper(paths.SvgOverdrive);
exports.Overhead = exports.SvgWrapper(paths.SvgOverhead);
exports.Overkill = exports.SvgWrapper(paths.SvgOverkill);
exports.Overmind = exports.SvgWrapper(paths.SvgOvermind);
exports.Owl = exports.SvgWrapper(paths.SvgOwl);
exports.P90 = exports.SvgWrapper(paths.SvgP90);
exports.Padlock = exports.SvgWrapper(paths.SvgPadlock);
exports.Palm = exports.SvgWrapper(paths.SvgPalm);
exports.Paper = exports.SvgWrapper(paths.SvgPaper);
exports.PaperArrow = exports.SvgWrapper(paths.SvgPaperArrow);
exports.PaperBomb = exports.SvgWrapper(paths.SvgPaperBomb);
exports.PaperLantern = exports.SvgWrapper(paths.SvgPaperLantern);
exports.Papers = exports.SvgWrapper(paths.SvgPapers);
exports.Parachute = exports.SvgWrapper(paths.SvgParachute);
exports.Paranoia = exports.SvgWrapper(paths.SvgParanoia);
exports.Parmecia = exports.SvgWrapper(paths.SvgParmecia);
exports.ParrotHead = exports.SvgWrapper(paths.SvgParrotHead);
exports.Pauldrons = exports.SvgWrapper(paths.SvgPauldrons);
exports.PauseButton = exports.SvgWrapper(paths.SvgPauseButton);
exports.Paw = exports.SvgWrapper(paths.SvgPaw);
exports.PawFront = exports.SvgWrapper(paths.SvgPawFront);
exports.PawHeart = exports.SvgWrapper(paths.SvgPawHeart);
exports.PawPrint = exports.SvgWrapper(paths.SvgPawprint);
exports.Pawn = exports.SvgWrapper(paths.SvgPawn);
exports.Pc = exports.SvgWrapper(paths.SvgPc);
exports.Peaks = exports.SvgWrapper(paths.SvgPeaks);
exports.Peanut = exports.SvgWrapper(paths.SvgPeanut);
exports.Pegasus = exports.SvgWrapper(paths.SvgPegasus);
exports.Pentacle = exports.SvgWrapper(paths.SvgPentacle);
exports.PentagramRose = exports.SvgWrapper(paths.SvgPentagramRose);
exports.PentarrowsTornado = exports.SvgWrapper(paths.SvgPentarrowsTornado);
exports.PerfumeBottle = exports.SvgWrapper(paths.SvgPerfumeBottle);
exports.PerpendicularRings = exports.SvgWrapper(paths.SvgPerpendicularRings);
exports.PestleMortar = exports.SvgWrapper(paths.SvgPestleMortar);
exports.Pickelhaube = exports.SvgWrapper(paths.SvgPickelhaube);
exports.PieSlice = exports.SvgWrapper(paths.SvgPieSlice);
exports.PieceSkull = exports.SvgWrapper(paths.SvgPieceSkull);
exports.PiercedBody = exports.SvgWrapper(paths.SvgPiercedBody);
exports.PiercedHeart = exports.SvgWrapper(paths.SvgPiercedHeart);
exports.PiercingSword = exports.SvgWrapper(paths.SvgPiercingSword);
exports.Pig = exports.SvgWrapper(paths.SvgPig);
exports.PigFace = exports.SvgWrapper(paths.SvgPigFace);
exports.Pill = exports.SvgWrapper(paths.SvgPill);
exports.PillDrop = exports.SvgWrapper(paths.SvgPillDrop);
exports.Pincers = exports.SvgWrapper(paths.SvgPincers);
exports.PineTree = exports.SvgWrapper(paths.SvgPineTree);
exports.PirateGrave = exports.SvgWrapper(paths.SvgPirateGrave);
exports.PirateSkull = exports.SvgWrapper(paths.SvgPirateSkull);
exports.PistolGun = exports.SvgWrapper(paths.SvgPistolGun);
exports.PizzaCutter = exports.SvgWrapper(paths.SvgPizzaCutter);
exports.PlainDagger = exports.SvgWrapper(paths.SvgPlainDagger);
exports.PlantsAndAnimals = exports.SvgWrapper(paths.SvgPlantsAndAnimals);
exports.PlasmaBolt = exports.SvgWrapper(paths.SvgPlasmaBolt);
exports.Plastron = exports.SvgWrapper(paths.SvgPlastron);
exports.PlateClaw = exports.SvgWrapper(paths.SvgPlateClaw);
exports.Platform = exports.SvgWrapper(paths.SvgPlatform);
exports.PlayButton = exports.SvgWrapper(paths.SvgPlayButton);
exports.PocketBow = exports.SvgWrapper(paths.SvgPocketBow);
exports.PocketWatch = exports.SvgWrapper(paths.SvgPocketWatch);
exports.Pointing = exports.SvgWrapper(paths.SvgPointing);
exports.PointyHat = exports.SvgWrapper(paths.SvgPointyHat);
exports.PointySword = exports.SvgWrapper(paths.SvgPointySword);
exports.Poison = exports.SvgWrapper(paths.SvgPoison);
exports.PoisonBottle = exports.SvgWrapper(paths.SvgPoisonBottle);
exports.PoisonCloud = exports.SvgWrapper(paths.SvgPoisonCloud);
exports.PoisonGas = exports.SvgWrapper(paths.SvgPoisonGas);
exports.Pokecog = exports.SvgWrapper(paths.SvgPokecog);
exports.PokerHand = exports.SvgWrapper(paths.SvgPokerHand);
exports.PolarBear = exports.SvgWrapper(paths.SvgPolarBear);
exports.PoliceBadge = exports.SvgWrapper(paths.SvgPoliceBadge);
exports.PollenDust = exports.SvgWrapper(paths.SvgPollenDust);
exports.Poppy = exports.SvgWrapper(paths.SvgPoppy);
exports.Portal = exports.SvgWrapper(paths.SvgPortal);
exports.Portculis = exports.SvgWrapper(paths.SvgPortculis);
exports.PotionBall = exports.SvgWrapper(paths.SvgPotionBall);
exports.PotionOfMadness = exports.SvgWrapper(paths.SvgPotionOfMadness);
exports.Pounce = exports.SvgWrapper(paths.SvgPounce);
exports.PouringChalice = exports.SvgWrapper(paths.SvgPouringChalice);
exports.Powder = exports.SvgWrapper(paths.SvgPowder);
exports.PowerButton = exports.SvgWrapper(paths.SvgPowerButton);
exports.PowerLightning = exports.SvgWrapper(paths.SvgPowerLightning);
exports.Prayer = exports.SvgWrapper(paths.SvgPrayer);
exports.PrettyFangs = exports.SvgWrapper(paths.SvgPrettyFangs);
exports.Processor = exports.SvgWrapper(paths.SvgProcessor);
exports.Profit = exports.SvgWrapper(paths.SvgProfit);
exports.PsychicWaves = exports.SvgWrapper(paths.SvgPsychicWaves);
exports.Pteruges = exports.SvgWrapper(paths.SvgPteruges);
exports.Pulse = exports.SvgWrapper(paths.SvgPulse);
exports.Pummeled = exports.SvgWrapper(paths.SvgPummeled);
exports.PumpkinLantern = exports.SvgWrapper(paths.SvgPumpkinLantern);
exports.PumpkinMask = exports.SvgWrapper(paths.SvgPumpkinMask);
exports.Punch = exports.SvgWrapper(paths.SvgPunch);
exports.PunchBlast = exports.SvgWrapper(paths.SvgPunchBlast);
exports.Puppet = exports.SvgWrapper(paths.SvgPuppet);
exports.Pyromaniac = exports.SvgWrapper(paths.SvgPyromaniac);
exports.QuakeStomp = exports.SvgWrapper(paths.SvgQuakeStomp);
exports.QueenCrown = exports.SvgWrapper(paths.SvgQueenCrown);
exports.QuickSlash = exports.SvgWrapper(paths.SvgQuickSlash);
exports.Quicksand = exports.SvgWrapper(paths.SvgQuicksand);
exports.Quill = exports.SvgWrapper(paths.SvgQuill);
exports.QuillInk = exports.SvgWrapper(paths.SvgQuillInk);
exports.RaceCar = exports.SvgWrapper(paths.SvgRaceCar);
exports.RadarDish = exports.SvgWrapper(paths.SvgRadarDish);
exports.RadarSweep = exports.SvgWrapper(paths.SvgRadarSweep);
exports.RadialBalance = exports.SvgWrapper(paths.SvgRadialBalance);
exports.Radioactive = exports.SvgWrapper(paths.SvgRadioactive);
exports.RaggedWound = exports.SvgWrapper(paths.SvgRaggedWound);
exports.RainbowStar = exports.SvgWrapper(paths.SvgRainbowStar);
exports.Raining = exports.SvgWrapper(paths.SvgRaining);
exports.RaiseSkeleton = exports.SvgWrapper(paths.SvgRaiseSkeleton);
exports.RaiseZombie = exports.SvgWrapper(paths.SvgRaiseZombie);
exports.RallyTheTroops = exports.SvgWrapper(paths.SvgRallyTheTroops);
exports.Ram = exports.SvgWrapper(paths.SvgRam);
exports.Rank1 = exports.SvgWrapper(paths.SvgRank1);
exports.Rank2 = exports.SvgWrapper(paths.SvgRank2);
exports.Rank3 = exports.SvgWrapper(paths.SvgRank3);
exports.RapidshareArrow = exports.SvgWrapper(paths.SvgRapidshareArrow);
exports.Raven = exports.SvgWrapper(paths.SvgRaven);
exports.RayGun = exports.SvgWrapper(paths.SvgRayGun);
exports.RazorBlade = exports.SvgWrapper(paths.SvgRazorBlade);
exports.Reactor = exports.SvgWrapper(paths.SvgReactor);
exports.Read = exports.SvgWrapper(paths.SvgRead);
exports.ReaperScythe = exports.SvgWrapper(paths.SvgReaperScythe);
exports.RearAura = exports.SvgWrapper(paths.SvgRearAura);
exports.Recycle = exports.SvgWrapper(paths.SvgRecycle);
exports.Regeneration = exports.SvgWrapper(paths.SvgRegeneration);
exports.RelationshipBounds = exports.SvgWrapper(paths.SvgRelationshipBounds);
exports.RelicBlade = exports.SvgWrapper(paths.SvgRelicBlade);
exports.Resonance = exports.SvgWrapper(paths.SvgResonance);
exports.Reticule = exports.SvgWrapper(paths.SvgReticule);
exports.RetroController = exports.SvgWrapper(paths.SvgRetroController);
exports.ReturnArrow = exports.SvgWrapper(paths.SvgReturnArrow);
exports.Revolt = exports.SvgWrapper(paths.SvgRevolt);
exports.Revolver = exports.SvgWrapper(paths.SvgRevolver);
exports.Ribbon = exports.SvgWrapper(paths.SvgRibbon);
exports.Ribcage = exports.SvgWrapper(paths.SvgRibcage);
exports.Rifle = exports.SvgWrapper(paths.SvgRifle);
exports.RingedBeam = exports.SvgWrapper(paths.SvgRingedBeam);
exports.RingedPlanet = exports.SvgWrapper(paths.SvgRingedPlanet);
exports.RingingBell = exports.SvgWrapper(paths.SvgRingingBell);
exports.RiotShield = exports.SvgWrapper(paths.SvgRiotShield);
exports.RoastChicken = exports.SvgWrapper(paths.SvgRoastChicken);
exports.RobberHand = exports.SvgWrapper(paths.SvgRobberHand);
exports.Robe = exports.SvgWrapper(paths.SvgRobe);
exports.RobotGolem = exports.SvgWrapper(paths.SvgRobotGolem);
exports.Rock = exports.SvgWrapper(paths.SvgRock);
exports.Rocket = exports.SvgWrapper(paths.SvgRocket);
exports.RocketFlight = exports.SvgWrapper(paths.SvgRocketFlight);
exports.Rogue = exports.SvgWrapper(paths.SvgRogue);
exports.RollingBomb = exports.SvgWrapper(paths.SvgRollingBomb);
exports.RollingEnergy = exports.SvgWrapper(paths.SvgRollingEnergy);
exports.RootTip = exports.SvgWrapper(paths.SvgRootTip);
exports.RosaShield = exports.SvgWrapper(paths.SvgRosaShield);
exports.Rose = exports.SvgWrapper(paths.SvgRose);
exports.RoughWound = exports.SvgWrapper(paths.SvgRoughWound);
exports.RoundBottomFlask = exports.SvgWrapper(paths.SvgRoundBottomFlask);
exports.RoundShield = exports.SvgWrapper(paths.SvgRoundShield);
exports.RoundStruck = exports.SvgWrapper(paths.SvgRoundStruck);
exports.RoyalLove = exports.SvgWrapper(paths.SvgRoyalLove);
exports.Rss = exports.SvgWrapper(paths.SvgRss);
exports.Run = exports.SvgWrapper(paths.SvgRun);
exports.RuneStone = exports.SvgWrapper(paths.SvgRuneStone);
exports.RuneSword = exports.SvgWrapper(paths.SvgRuneSword);
exports.RunningNinja = exports.SvgWrapper(paths.SvgRunningNinja);
exports.SaberSlash = exports.SvgWrapper(paths.SvgSaberSlash);
exports.SaberTooth = exports.SvgWrapper(paths.SvgSaberTooth);
exports.SabersChoc = exports.SvgWrapper(paths.SvgSabersChoc);
exports.SacrificialDagger = exports.SvgWrapper(paths.SvgSacrificialDagger);
exports.SadCrab = exports.SvgWrapper(paths.SvgSadCrab);
exports.Salamander = exports.SvgWrapper(paths.SvgSalamander);
exports.Salmon = exports.SvgWrapper(paths.SvgSalmon);
exports.SaltShaker = exports.SvgWrapper(paths.SvgSaltShaker);
exports.SandsOfTime = exports.SvgWrapper(paths.SvgSandsOfTime);
exports.Saphir = exports.SvgWrapper(paths.SvgSaphir);
exports.Sattelite = exports.SvgWrapper(paths.SvgSattelite);
exports.SawClaw = exports.SvgWrapper(paths.SvgSawClaw);
exports.ScaleMail = exports.SvgWrapper(paths.SvgScaleMail);
exports.Scales = exports.SvgWrapper(paths.SvgScales);
exports.Scallop = exports.SvgWrapper(paths.SvgScallop);
exports.Scalpel = exports.SvgWrapper(paths.SvgScalpel);
exports.ScalpelStrike = exports.SvgWrapper(paths.SvgScalpelStrike);
exports.ScarWound = exports.SvgWrapper(paths.SvgScarWound);
exports.ScarabBeetle = exports.SvgWrapper(paths.SvgScarabBeetle);
exports.Scarecrow = exports.SvgWrapper(paths.SvgScarecrow);
exports.Scissors = exports.SvgWrapper(paths.SvgScissors);
exports.Scorpion = exports.SvgWrapper(paths.SvgScorpion);
exports.ScorpionTail = exports.SvgWrapper(paths.SvgScorpionTail);
exports.Screaming = exports.SvgWrapper(paths.SvgScreaming);
exports.ScreenImpact = exports.SvgWrapper(paths.SvgScreenImpact);
exports.Screw = exports.SvgWrapper(paths.SvgScrew);
exports.Screwdriver = exports.SvgWrapper(paths.SvgScrewdriver);
exports.ScrollUnfurled = exports.SvgWrapper(paths.SvgScrollUnfurled);
exports.Scythe = exports.SvgWrapper(paths.SvgScythe);
exports.SeaCreature = exports.SvgWrapper(paths.SvgSeaCreature);
exports.SeaDragon = exports.SvgWrapper(paths.SvgSeaDragon);
exports.SeaSerpent = exports.SvgWrapper(paths.SvgSeaSerpent);
exports.SeatedMouse = exports.SvgWrapper(paths.SvgSeatedMouse);
exports.Select = exports.SvgWrapper(paths.SvgSelect);
exports.SelfLove = exports.SvgWrapper(paths.SvgSelfLove);
exports.SemiClosedEye = exports.SvgWrapper(paths.SvgSemiClosedEye);
exports.Sensuousness = exports.SvgWrapper(paths.SvgSensuousness);
exports.SentryGun = exports.SvgWrapper(paths.SvgSentryGun);
exports.SerratedSlash = exports.SvgWrapper(paths.SvgSerratedSlash);
exports.SeveredHand = exports.SvgWrapper(paths.SvgSeveredHand);
exports.SewedShell = exports.SvgWrapper(paths.SvgSewedShell);
exports.SewingNeedle = exports.SvgWrapper(paths.SvgSewingNeedle);
exports.ShadowFollower = exports.SvgWrapper(paths.SvgShadowFollower);
exports.ShadowGrasp = exports.SvgWrapper(paths.SvgShadowGrasp);
exports.ShardSword = exports.SvgWrapper(paths.SvgShardSword);
exports.SharkJaws = exports.SvgWrapper(paths.SvgSharkJaws);
exports.SharpCrown = exports.SvgWrapper(paths.SvgSharpCrown);
exports.SharpLips = exports.SvgWrapper(paths.SvgSharpLips);
exports.SharpShuriken = exports.SvgWrapper(paths.SvgSharpShuriken);
exports.SharpSmile = exports.SvgWrapper(paths.SvgSharpSmile);
exports.SharpedTeethSkull = exports.SvgWrapper(paths.SvgSharpedTeethSkull);
exports.Shatter = exports.SvgWrapper(paths.SvgShatter);
exports.ShatteredGlass = exports.SvgWrapper(paths.SvgShatteredGlass);
exports.ShatteredSword = exports.SvgWrapper(paths.SvgShatteredSword);
exports.SheikahEye = exports.SvgWrapper(paths.SvgSheikahEye);
exports.ShepherdsCrook = exports.SvgWrapper(paths.SvgShepherdsCrook);
exports.Shield = exports.SvgWrapper(paths.SvgShield);
exports.ShieldBounces = exports.SvgWrapper(paths.SvgShieldBounces);
exports.ShieldDisabled = exports.SvgWrapper(paths.SvgShieldDisabled);
exports.ShieldEchoes = exports.SvgWrapper(paths.SvgShieldEchoes);
exports.ShieldReflect = exports.SvgWrapper(paths.SvgShieldReflect);
exports.Shieldcomb = exports.SvgWrapper(paths.SvgShieldcomb);
exports.ShiningClaw = exports.SvgWrapper(paths.SvgShiningClaw);
exports.ShiningHeart = exports.SvgWrapper(paths.SvgShiningHeart);
exports.ShiningSword = exports.SvgWrapper(paths.SvgShiningSword);
exports.ShinyApple = exports.SvgWrapper(paths.SvgShinyApple);
exports.ShinyEntrance = exports.SvgWrapper(paths.SvgShinyEntrance);
exports.ShinyIris = exports.SvgWrapper(paths.SvgShinyIris);
exports.ShinyOmega = exports.SvgWrapper(paths.SvgShinyOmega);
exports.ShinyPurse = exports.SvgWrapper(paths.SvgShinyPurse);
exports.Shirt = exports.SvgWrapper(paths.SvgShirt);
exports.Shotgun = exports.SvgWrapper(paths.SvgShotgun);
exports.ShoulderScales = exports.SvgWrapper(paths.SvgShoulderScales);
exports.Shouting = exports.SvgWrapper(paths.SvgShouting);
exports.Shuriken = exports.SvgWrapper(paths.SvgShuriken);
exports.ShurikenAperture = exports.SvgWrapper(paths.SvgShurikenAperture);
exports.ShutRose = exports.SvgWrapper(paths.SvgShutRose);
exports.Sideswipe = exports.SvgWrapper(paths.SvgSideswipe);
exports.SiegeRam = exports.SvgWrapper(paths.SvgSiegeRam);
exports.SightDisabled = exports.SvgWrapper(paths.SvgSightDisabled);
exports.Silence = exports.SvgWrapper(paths.SvgSilence);
exports.Sing = exports.SvgWrapper(paths.SvgSing);
exports.SinkingTrap = exports.SvgWrapper(paths.SvgSinkingTrap);
exports.SinusoidalBeam = exports.SvgWrapper(paths.SvgSinusoidalBeam);
exports.Siren = exports.SvgWrapper(paths.SvgSiren);
exports.SixEyes = exports.SvgWrapper(paths.SvgSixEyes);
exports.Skeleton = exports.SvgWrapper(paths.SvgSkeleton);
exports.SkeletonInside = exports.SvgWrapper(paths.SvgSkeletonInside);
exports.SkeletonKey = exports.SvgWrapper(paths.SvgSkeletonKey);
exports.SkidMark = exports.SvgWrapper(paths.SvgSkidMark);
exports.SkullBolt = exports.SvgWrapper(paths.SvgSkullBolt);
exports.SkullCrack = exports.SvgWrapper(paths.SvgSkullCrack);
exports.SkullCrossedBones = exports.SvgWrapper(paths.SvgSkullCrossedBones);
exports.SkullInJar = exports.SvgWrapper(paths.SvgSkullInJar);
exports.SkullMask = exports.SvgWrapper(paths.SvgSkullMask);
exports.SkullRing = exports.SvgWrapper(paths.SvgSkullRing);
exports.SkullSabertooth = exports.SvgWrapper(paths.SvgSkullSabertooth);
exports.SkullShield = exports.SvgWrapper(paths.SvgSkullShield);
exports.SkullSignet = exports.SvgWrapper(paths.SvgSkullSignet);
exports.SkullSlices = exports.SvgWrapper(paths.SvgSkullSlices);
exports.SkullWithSyringe = exports.SvgWrapper(paths.SvgSkullWithSyringe);
exports.Slap = exports.SvgWrapper(paths.SvgSlap);
exports.SlashedShield = exports.SvgWrapper(paths.SvgSlashedShield);
exports.SlaveryWhip = exports.SvgWrapper(paths.SvgSlaveryWhip);
exports.Sleepy = exports.SvgWrapper(paths.SvgSleepy);
exports.SlicedBread = exports.SvgWrapper(paths.SvgSlicedBread);
exports.SlicingArrow = exports.SvgWrapper(paths.SvgSlicingArrow);
exports.SlowBlob = exports.SvgWrapper(paths.SvgSlowBlob);
exports.Sly = exports.SvgWrapper(paths.SvgSly);
exports.SmallFire = exports.SvgWrapper(paths.SvgSmallFire);
exports.Smartphone = exports.SvgWrapper(paths.SvgSmartphone);
exports.SmashArrows = exports.SvgWrapper(paths.SvgSmashArrows);
exports.Smitten = exports.SvgWrapper(paths.SvgSmitten);
exports.SmokeBomb = exports.SvgWrapper(paths.SvgSmokeBomb);
exports.SmokingFinger = exports.SvgWrapper(paths.SvgSmokingFinger);
exports.SmokingOrb = exports.SvgWrapper(paths.SvgSmokingOrb);
exports.Snail = exports.SvgWrapper(paths.SvgSnail);
exports.Snake = exports.SvgWrapper(paths.SvgSnake);
exports.SnakeBite = exports.SvgWrapper(paths.SvgSnakeBite);
exports.SnakeTotem = exports.SvgWrapper(paths.SvgSnakeTotem);
exports.Snatch = exports.SvgWrapper(paths.SvgSnatch);
exports.Snorkel = exports.SvgWrapper(paths.SvgSnorkel);
exports.Snout = exports.SvgWrapper(paths.SvgSnout);
exports.SnowBottle = exports.SvgWrapper(paths.SvgSnowBottle);
exports.Snowflake1 = exports.SvgWrapper(paths.SvgSnowflake1);
exports.Snowflake2 = exports.SvgWrapper(paths.SvgSnowflake2);
exports.Snowing = exports.SvgWrapper(paths.SvgSnowing);
exports.Snowman = exports.SvgWrapper(paths.SvgSnowman);
exports.SoapExperiment = exports.SvgWrapper(paths.SvgSoapExperiment);
exports.SodaCan = exports.SvgWrapper(paths.SvgSodaCan);
exports.SolarPower = exports.SvgWrapper(paths.SvgSolarPower);
exports.SonicBoom = exports.SvgWrapper(paths.SvgSonicBoom);
exports.SonicLightning = exports.SvgWrapper(paths.SvgSonicLightning);
exports.SonicScreech = exports.SvgWrapper(paths.SvgSonicScreech);
exports.SonicShout = exports.SvgWrapper(paths.SvgSonicShout);
exports.SoundWaves = exports.SvgWrapper(paths.SvgSoundWaves);
exports.SpaceSuit = exports.SvgWrapper(paths.SvgSpaceSuit);
exports.Spade = exports.SvgWrapper(paths.SvgSpade);
exports.SpadeSkull = exports.SvgWrapper(paths.SvgSpadeSkull);
exports.Spades = exports.SvgWrapper(paths.SvgSpades);
exports.Spanner = exports.SvgWrapper(paths.SvgSpanner);
exports.SparkSpirit = exports.SvgWrapper(paths.SvgSparkSpirit);
exports.SparklingSabre = exports.SvgWrapper(paths.SvgSparklingSabre);
exports.SparkyBomb = exports.SvgWrapper(paths.SvgSparkyBomb);
exports.Sparrow = exports.SvgWrapper(paths.SvgSparrow);
exports.Spartan = exports.SvgWrapper(paths.SvgSpartan);
exports.Spatter = exports.SvgWrapper(paths.SvgSpatter);
exports.SpawnNode = exports.SvgWrapper(paths.SvgSpawnNode);
exports.SpearHook = exports.SvgWrapper(paths.SvgSpearHook);
exports.Spears = exports.SvgWrapper(paths.SvgSpears);
exports.SpectacleLenses = exports.SvgWrapper(paths.SvgSpectacleLenses);
exports.Spectacles = exports.SvgWrapper(paths.SvgSpectacles);
exports.Spectre = exports.SvgWrapper(paths.SvgSpectre);
exports.SpectreM4 = exports.SvgWrapper(paths.SvgSpectreM4);
exports.SpiderAlt = exports.SvgWrapper(paths.SvgSpiderAlt);
exports.SpiderFace = exports.SvgWrapper(paths.SvgSpiderFace);
exports.SpiderWeb = exports.SvgWrapper(paths.SvgSpiderWeb);
exports.Spikeball = exports.SvgWrapper(paths.SvgSpikeball);
exports.SpikedArmor = exports.SvgWrapper(paths.SvgSpikedArmor);
exports.SpikedBall = exports.SvgWrapper(paths.SvgSpikedBall);
exports.SpikedBat = exports.SvgWrapper(paths.SvgSpikedBat);
exports.SpikedCollar = exports.SvgWrapper(paths.SvgSpikedCollar);
exports.SpikedFence = exports.SvgWrapper(paths.SvgSpikedFence);
exports.SpikedHalo = exports.SvgWrapper(paths.SvgSpikedHalo);
exports.SpikedMace = exports.SvgWrapper(paths.SvgSpikedMace);
exports.SpikedShell = exports.SvgWrapper(paths.SvgSpikedShell);
exports.SpikedSnail = exports.SvgWrapper(paths.SvgSpikedSnail);
exports.SpikedTail = exports.SvgWrapper(paths.SvgSpikedTail);
exports.SpikedTentacle = exports.SvgWrapper(paths.SvgSpikedTentacle);
exports.Spikes = exports.SvgWrapper(paths.SvgSpikes);
exports.SpikesFull = exports.SvgWrapper(paths.SvgSpikesFull);
exports.SpikesHalf = exports.SvgWrapper(paths.SvgSpikesHalf);
exports.SpikesInit = exports.SvgWrapper(paths.SvgSpikesInit);
exports.SpikyEclipse = exports.SvgWrapper(paths.SvgSpikyEclipse);
exports.SpikyExplosion = exports.SvgWrapper(paths.SvgSpikyExplosion);
exports.SpikyField = exports.SvgWrapper(paths.SvgSpikyField);
exports.Spill = exports.SvgWrapper(paths.SvgSpill);
exports.SpinalCoil = exports.SvgWrapper(paths.SvgSpinalCoil);
exports.SpineArrow = exports.SvgWrapper(paths.SvgSpineArrow);
exports.SpinningBlades = exports.SvgWrapper(paths.SvgSpinningBlades);
exports.SpinningRibbons = exports.SvgWrapper(paths.SvgSpinningRibbons);
exports.SpinningSword = exports.SvgWrapper(paths.SvgSpinningSword);
exports.SpinningTop = exports.SvgWrapper(paths.SvgSpinningTop);
exports.SpiralArrow = exports.SvgWrapper(paths.SvgSpiralArrow);
exports.SpiralBloom = exports.SvgWrapper(paths.SvgSpiralBloom);
exports.SpiralBottle = exports.SvgWrapper(paths.SvgSpiralBottle);
exports.SpiralShell = exports.SvgWrapper(paths.SvgSpiralShell);
exports.SpiralTentacle = exports.SvgWrapper(paths.SvgSpiralTentacle);
exports.SpiralThrust = exports.SvgWrapper(paths.SvgSpiralThrust);
exports.Splash = exports.SvgWrapper(paths.SvgSplash);
exports.SplashyStream = exports.SvgWrapper(paths.SvgSplashyStream);
exports.SplitBody = exports.SvgWrapper(paths.SvgSplitBody);
exports.SplitCross = exports.SvgWrapper(paths.SvgSplitCross);
exports.Splurt = exports.SvgWrapper(paths.SvgSplurt);
exports.Spoon = exports.SvgWrapper(paths.SvgSpoon);
exports.SpotedFlower = exports.SvgWrapper(paths.SvgSpotedFlower);
exports.SpottedArrowhead = exports.SvgWrapper(paths.SvgSpottedArrowhead);
exports.SpottedBug = exports.SvgWrapper(paths.SvgSpottedBug);
exports.SpottedMushroom = exports.SvgWrapper(paths.SvgSpottedMushroom);
exports.SpottedWound = exports.SvgWrapper(paths.SvgSpottedWound);
exports.Spoutnik = exports.SvgWrapper(paths.SvgSpoutnik);
exports.Spray = exports.SvgWrapper(paths.SvgSpray);
exports.Sprint = exports.SvgWrapper(paths.SvgSprint);
exports.Sprout = exports.SvgWrapper(paths.SvgSprout);
exports.SproutDisc = exports.SvgWrapper(paths.SvgSproutDisc);
exports.Spyglass = exports.SvgWrapper(paths.SvgSpyglass);
exports.SquareBottle = exports.SvgWrapper(paths.SvgSquareBottle);
exports.Squib = exports.SvgWrapper(paths.SvgSquib);
exports.Squid = exports.SvgWrapper(paths.SvgSquid);
exports.SquidHead = exports.SvgWrapper(paths.SvgSquidHead);
exports.StagHead = exports.SvgWrapper(paths.SvgStagHead);
exports.Stahlhelm = exports.SvgWrapper(paths.SvgStahlhelm);
exports.Stalagtite = exports.SvgWrapper(paths.SvgStalagtite);
exports.StandingPotion = exports.SvgWrapper(paths.SvgStandingPotion);
exports.StarCycle = exports.SvgWrapper(paths.SvgStarCycle);
exports.StarProminences = exports.SvgWrapper(paths.SvgStarProminences);
exports.StarPupil = exports.SvgWrapper(paths.SvgStarPupil);
exports.StarSattelites = exports.SvgWrapper(paths.SvgStarSattelites);
exports.StarShuriken = exports.SvgWrapper(paths.SvgStarShuriken);
exports.StarSkull = exports.SvgWrapper(paths.SvgStarSkull);
exports.StarSwirl = exports.SvgWrapper(paths.SvgStarSwirl);
exports.Staryu = exports.SvgWrapper(paths.SvgStaryu);
exports.Static = exports.SvgWrapper(paths.SvgStatic);
exports.StaticGuard = exports.SvgWrapper(paths.SvgStaticGuard);
exports.StaticWaves = exports.SvgWrapper(paths.SvgStaticWaves);
exports.SteelClaws = exports.SvgWrapper(paths.SvgSteelClaws);
exports.SteelDoor = exports.SvgWrapper(paths.SvgSteelDoor);
exports.SteeltoeBoots = exports.SvgWrapper(paths.SvgSteeltoeBoots);
exports.SteelwingEmblem = exports.SvgWrapper(paths.SvgSteelwingEmblem);
exports.SteyrAug = exports.SvgWrapper(paths.SvgSteyrAug);
exports.StickGrenade = exports.SvgWrapper(paths.SvgStickGrenade);
exports.StickSplitting = exports.SvgWrapper(paths.SvgStickSplitting);
exports.StickingPlaster = exports.SvgWrapper(paths.SvgStickingPlaster);
exports.Stigmata = exports.SvgWrapper(paths.SvgStigmata);
exports.Stiletto = exports.SvgWrapper(paths.SvgStiletto);
exports.StitchedWound = exports.SvgWrapper(paths.SvgStitchedWound);
exports.Stomp = exports.SvgWrapper(paths.SvgStomp);
exports.StompTornado = exports.SvgWrapper(paths.SvgStompTornado);
exports.StoneAxe = exports.SvgWrapper(paths.SvgStoneAxe);
exports.StoneBlock = exports.SvgWrapper(paths.SvgStoneBlock);
exports.StoneCrafting = exports.SvgWrapper(paths.SvgStoneCrafting);
exports.StoneSpear = exports.SvgWrapper(paths.SvgStoneSpear);
exports.StoneSphere = exports.SvgWrapper(paths.SvgStoneSphere);
exports.StoneTablet = exports.SvgWrapper(paths.SvgStoneTablet);
exports.StoneThrone = exports.SvgWrapper(paths.SvgStoneThrone);
exports.StoneTower = exports.SvgWrapper(paths.SvgStoneTower);
exports.StonedSkull = exports.SvgWrapper(paths.SvgStonedSkull);
exports.Stopwatch = exports.SvgWrapper(paths.SvgStopwatch);
exports.Strafe = exports.SvgWrapper(paths.SvgStrafe);
exports.StrikingArrows = exports.SvgWrapper(paths.SvgStrikingArrows);
exports.StrikingBalls = exports.SvgWrapper(paths.SvgStrikingBalls);
exports.StrikingClamps = exports.SvgWrapper(paths.SvgStrikingClamps);
exports.StrikingDiamonds = exports.SvgWrapper(paths.SvgStrikingDiamonds);
exports.StrikingSplinter = exports.SvgWrapper(paths.SvgStrikingSplinter);
exports.StripedSword = exports.SvgWrapper(paths.SvgStripedSword);
exports.Strong = exports.SvgWrapper(paths.SvgStrong);
exports.SuckeredTentacle = exports.SvgWrapper(paths.SvgSuckeredTentacle);
exports.Suicide = exports.SvgWrapper(paths.SvgSuicide);
exports.Suits = exports.SvgWrapper(paths.SvgSuits);
exports.Sun = exports.SvgWrapper(paths.SvgSun);
exports.SunRadiations = exports.SvgWrapper(paths.SvgSunRadiations);
exports.Sunbeams = exports.SvgWrapper(paths.SvgSunbeams);
exports.Sundial = exports.SvgWrapper(paths.SvgSundial);
exports.SunkenEye = exports.SvgWrapper(paths.SvgSunkenEye);
exports.Sunrise = exports.SvgWrapper(paths.SvgSunrise);
exports.SuperMushroom = exports.SvgWrapper(paths.SvgSuperMushroom);
exports.SupersonicArrow = exports.SvgWrapper(paths.SvgSupersonicArrow);
exports.SupersonicBullet = exports.SvgWrapper(paths.SvgSupersonicBullet);
exports.Surprised = exports.SvgWrapper(paths.SvgSurprised);
exports.SurprisedSkull = exports.SvgWrapper(paths.SvgSurprisedSkull);
exports.SurroundedEye = exports.SvgWrapper(paths.SvgSurroundedEye);
exports.SurroundedShield = exports.SvgWrapper(paths.SvgSurroundedShield);
exports.Suspicious = exports.SvgWrapper(paths.SvgSuspicious);
exports.Swallow = exports.SvgWrapper(paths.SvgSwallow);
exports.Swan = exports.SvgWrapper(paths.SvgSwan);
exports.SwanBreeze = exports.SvgWrapper(paths.SvgSwanBreeze);
exports.SwapBag = exports.SvgWrapper(paths.SvgSwapBag);
exports.SwirlRing = exports.SvgWrapper(paths.SvgSwirlRing);
exports.SwirlString = exports.SvgWrapper(paths.SvgSwirlString);
exports.SwirledShell = exports.SvgWrapper(paths.SvgSwirledShell);
exports.Switchblade = exports.SvgWrapper(paths.SvgSwitchblade);
exports.SwordArray = exports.SvgWrapper(paths.SvgSwordArray);
exports.SwordBreak = exports.SvgWrapper(paths.SvgSwordBreak);
exports.SwordClash = exports.SvgWrapper(paths.SvgSwordClash);
exports.SwordHilt = exports.SvgWrapper(paths.SvgSwordHilt);
exports.SwordInStone = exports.SvgWrapper(paths.SvgSwordInStone);
exports.SwordSlice = exports.SvgWrapper(paths.SvgSwordSlice);
exports.SwordSmithing = exports.SvgWrapper(paths.SvgSwordSmithing);
exports.SwordSpade = exports.SvgWrapper(paths.SvgSwordSpade);
exports.SwordSpin = exports.SvgWrapper(paths.SvgSwordSpin);
exports.SwordTie = exports.SvgWrapper(paths.SvgSwordTie);
exports.SwordWound = exports.SvgWrapper(paths.SvgSwordWound);
exports.Swordman = exports.SvgWrapper(paths.SvgSwordman);
exports.SwordsEmblem = exports.SvgWrapper(paths.SvgSwordsEmblem);
exports.Swordwoman = exports.SvgWrapper(paths.SvgSwordwoman);
exports.Syringe = exports.SvgWrapper(paths.SvgSyringe);
exports.TabiBoot = exports.SvgWrapper(paths.SvgTabiBoot);
exports.Tablet = exports.SvgWrapper(paths.SvgTablet);
exports.Talk = exports.SvgWrapper(paths.SvgTalk);
exports.Tank = exports.SvgWrapper(paths.SvgTank);
exports.TankTread = exports.SvgWrapper(paths.SvgTankTread);
exports.TargetArrows = exports.SvgWrapper(paths.SvgTargetArrows);
exports.TargetDummy = exports.SvgWrapper(paths.SvgTargetDummy);
exports.TargetLaser = exports.SvgWrapper(paths.SvgTargetLaser);
exports.TargetShot = exports.SvgWrapper(paths.SvgTargetShot);
exports.Targeted = exports.SvgWrapper(paths.SvgTargeted);
exports.Targeting = exports.SvgWrapper(paths.SvgTargeting);
exports.TatteredBanner = exports.SvgWrapper(paths.SvgTatteredBanner);
exports.Teapot = exports.SvgWrapper(paths.SvgTeapot);
exports.TearTracks = exports.SvgWrapper(paths.SvgTearTracks);
exports.Tearing = exports.SvgWrapper(paths.SvgTearing);
exports.Tec9 = exports.SvgWrapper(paths.SvgTec9);
exports.TechnoHeart = exports.SvgWrapper(paths.SvgTechnoHeart);
exports.Telefrag = exports.SvgWrapper(paths.SvgTelefrag);
exports.Telepathy = exports.SvgWrapper(paths.SvgTelepathy);
exports.Teleport = exports.SvgWrapper(paths.SvgTeleport);
exports.TelescopicBaton = exports.SvgWrapper(paths.SvgTelescopicBaton);
exports.TellerMine = exports.SvgWrapper(paths.SvgTellerMine);
exports.TemplarEye = exports.SvgWrapper(paths.SvgTemplarEye);
exports.TemplarHeart = exports.SvgWrapper(paths.SvgTemplarHeart);
exports.Temptation = exports.SvgWrapper(paths.SvgTemptation);
exports.TensionSnowflake = exports.SvgWrapper(paths.SvgTensionSnowflake);
exports.TentacleHeart = exports.SvgWrapper(paths.SvgTentacleHeart);
exports.TentacleStrike = exports.SvgWrapper(paths.SvgTentacleStrike);
exports.TentaclesSkull = exports.SvgWrapper(paths.SvgTentaclesSkull);
exports.Tentacurl = exports.SvgWrapper(paths.SvgTentacurl);
exports.Terror = exports.SvgWrapper(paths.SvgTerror);
exports.Tesla = exports.SvgWrapper(paths.SvgTesla);
exports.TeslaCoil = exports.SvgWrapper(paths.SvgTeslaCoil);
exports.TeslaTurret = exports.SvgWrapper(paths.SvgTeslaTurret);
exports.TestTubes = exports.SvgWrapper(paths.SvgTestTubes);
exports.ThermometerScale = exports.SvgWrapper(paths.SvgThermometerScale);
exports.ThirdEye = exports.SvgWrapper(paths.SvgThirdEye);
exports.ThompsonM1 = exports.SvgWrapper(paths.SvgThompsonM1);
exports.ThompsonM1928 = exports.SvgWrapper(paths.SvgThompsonM1928);
exports.ThorFist = exports.SvgWrapper(paths.SvgThorFist);
exports.ThornHelix = exports.SvgWrapper(paths.SvgThornHelix);
exports.ThornedArrow = exports.SvgWrapper(paths.SvgThornedArrow);
exports.ThornyTentacle = exports.SvgWrapper(paths.SvgThornyTentacle);
exports.ThornyVine = exports.SvgWrapper(paths.SvgThornyVine);
exports.ThreeBurningBalls = exports.SvgWrapper(paths.SvgThreeBurningBalls);
exports.ThreeKeys = exports.SvgWrapper(paths.SvgThreeKeys);
exports.ThreeLeaves = exports.SvgWrapper(paths.SvgThreeLeaves);
exports.ThreePointedShuriken = exports.SvgWrapper(paths.SvgThreePointedShuriken);
exports.ThrownCharcoal = exports.SvgWrapper(paths.SvgThrownCharcoal);
exports.ThrownDaggers = exports.SvgWrapper(paths.SvgThrownDaggers);
exports.ThrownKnife = exports.SvgWrapper(paths.SvgThrownKnife);
exports.ThrownSpear = exports.SvgWrapper(paths.SvgThrownSpear);
exports.Thrust = exports.SvgWrapper(paths.SvgThrust);
exports.ThunderBlade = exports.SvgWrapper(paths.SvgThunderBlade);
exports.ThunderSkull = exports.SvgWrapper(paths.SvgThunderSkull);
exports.ThunderStruck = exports.SvgWrapper(paths.SvgThunderStruck);
exports.Thunderball = exports.SvgWrapper(paths.SvgThunderball);
exports.Tick = exports.SvgWrapper(paths.SvgTick);
exports.TiedScroll = exports.SvgWrapper(paths.SvgTiedScroll);
exports.TimeBomb = exports.SvgWrapper(paths.SvgTimeBomb);
exports.TimeTrap = exports.SvgWrapper(paths.SvgTimeTrap);
exports.Tinker = exports.SvgWrapper(paths.SvgTinker);
exports.ToadTeeth = exports.SvgWrapper(paths.SvgToadTeeth);
exports.Tombstone = exports.SvgWrapper(paths.SvgTombstone);
exports.Tooth = exports.SvgWrapper(paths.SvgTooth);
exports.TopHat = exports.SvgWrapper(paths.SvgTopHat);
exports.TopPaw = exports.SvgWrapper(paths.SvgTopPaw);
exports.Topaz = exports.SvgWrapper(paths.SvgTopaz);
exports.Torc = exports.SvgWrapper(paths.SvgTorc);
exports.Tornado = exports.SvgWrapper(paths.SvgTornado);
exports.TornadoDiscs = exports.SvgWrapper(paths.SvgTornadoDiscs);
exports.TotemHead = exports.SvgWrapper(paths.SvgTotemHead);
exports.TotemMask = exports.SvgWrapper(paths.SvgTotemMask);
exports.TowerFall = exports.SvgWrapper(paths.SvgTowerFall);
exports.Trade = exports.SvgWrapper(paths.SvgTrade);
exports.Trample = exports.SvgWrapper(paths.SvgTrample);
exports.Transfuse = exports.SvgWrapper(paths.SvgTransfuse);
exports.TransparentSlime = exports.SvgWrapper(paths.SvgTransparentSlime);
exports.TransparentTubes = exports.SvgWrapper(paths.SvgTransparentTubes);
exports.TransportationRings = exports.SvgWrapper(paths.SvgTransportationRings);
exports.TrapMask = exports.SvgWrapper(paths.SvgTrapMask);
exports.Tread = exports.SvgWrapper(paths.SvgTread);
exports.TreasureMap = exports.SvgWrapper(paths.SvgTreasureMap);
exports.TreeBranch = exports.SvgWrapper(paths.SvgTreeBranch);
exports.TreeFace = exports.SvgWrapper(paths.SvgTreeFace);
exports.TrefoilLily = exports.SvgWrapper(paths.SvgTrefoilLily);
exports.TrefoilShuriken = exports.SvgWrapper(paths.SvgTrefoilShuriken);
exports.TrenchAssault = exports.SvgWrapper(paths.SvgTrenchAssault);
exports.TrenchBodyArmor = exports.SvgWrapper(paths.SvgTrenchBodyArmor);
exports.TrenchKnife = exports.SvgWrapper(paths.SvgTrenchKnife);
exports.TrenchSpade = exports.SvgWrapper(paths.SvgTrenchSpade);
exports.TribalMask = exports.SvgWrapper(paths.SvgTribalMask);
exports.Trident = exports.SvgWrapper(paths.SvgTrident);
exports.TriggerHurt = exports.SvgWrapper(paths.SvgTriggerHurt);
exports.Trilobite = exports.SvgWrapper(paths.SvgTrilobite);
exports.Triorb = exports.SvgWrapper(paths.SvgTriorb);
exports.TripleBeak = exports.SvgWrapper(paths.SvgTripleBeak);
exports.TripleClaws = exports.SvgWrapper(paths.SvgTripleClaws);
exports.TripleCorn = exports.SvgWrapper(paths.SvgTripleCorn);
exports.TripleLock = exports.SvgWrapper(paths.SvgTripleLock);
exports.TripleNeedle = exports.SvgWrapper(paths.SvgTripleNeedle);
exports.TriplePlier = exports.SvgWrapper(paths.SvgTriplePlier);
exports.TripleScratches = exports.SvgWrapper(paths.SvgTripleScratches);
exports.TripleShells = exports.SvgWrapper(paths.SvgTripleShells);
exports.TripleSkulls = exports.SvgWrapper(paths.SvgTripleSkulls);
exports.TripleYin = exports.SvgWrapper(paths.SvgTripleYin);
exports.Tripwire = exports.SvgWrapper(paths.SvgTripwire);
exports.TritonHead = exports.SvgWrapper(paths.SvgTritonHead);
exports.Troll = exports.SvgWrapper(paths.SvgTroll);
exports.TronArrow = exports.SvgWrapper(paths.SvgTronArrow);
exports.Trophy = exports.SvgWrapper(paths.SvgTrophy);
exports.Trousers = exports.SvgWrapper(paths.SvgTrousers);
exports.Tumor = exports.SvgWrapper(paths.SvgTumor);
exports.Tumulus = exports.SvgWrapper(paths.SvgTumulus);
exports.TunePitch = exports.SvgWrapper(paths.SvgTunePitch);
exports.Turd = exports.SvgWrapper(paths.SvgTurd);
exports.Turret = exports.SvgWrapper(paths.SvgTurret);
exports.Turtle = exports.SvgWrapper(paths.SvgTurtle);
exports.TurtleShell = exports.SvgWrapper(paths.SvgTurtleShell);
exports.TwinShell = exports.SvgWrapper(paths.SvgTwinShell);
exports.TwirlCenter = exports.SvgWrapper(paths.SvgTwirlCenter);
exports.TwirlyFlower = exports.SvgWrapper(paths.SvgTwirlyFlower);
exports.Twister = exports.SvgWrapper(paths.SvgTwister);
exports.TwoFeathers = exports.SvgWrapper(paths.SvgTwoFeathers);
exports.TwoShadows = exports.SvgWrapper(paths.SvgTwoShadows);
exports.Tyre = exports.SvgWrapper(paths.SvgTyre);
exports.UbisoftSun = exports.SvgWrapper(paths.SvgUbisoftSun);
exports.Ultrasound = exports.SvgWrapper(paths.SvgUltrasound);
exports.Umbrella = exports.SvgWrapper(paths.SvgUmbrella);
exports.Uncertainty = exports.SvgWrapper(paths.SvgUncertainty);
exports.Underhand = exports.SvgWrapper(paths.SvgUnderhand);
exports.UnfriendlyFire = exports.SvgWrapper(paths.SvgUnfriendlyFire);
exports.UnlitBomb = exports.SvgWrapper(paths.SvgUnlitBomb);
exports.UnlitCandelabra = exports.SvgWrapper(paths.SvgUnlitCandelabra);
exports.Unlocking = exports.SvgWrapper(paths.SvgUnlocking);
exports.Unplugged = exports.SvgWrapper(paths.SvgUnplugged);
exports.UnstableOrb = exports.SvgWrapper(paths.SvgUnstableOrb);
exports.UnstableProjectile = exports.SvgWrapper(paths.SvgUnstableProjectile);
exports.Usable = exports.SvgWrapper(paths.SvgUsable);
exports.Valley = exports.SvgWrapper(paths.SvgValley);
exports.VanillaFlower = exports.SvgWrapper(paths.SvgVanillaFlower);
exports.Vial = exports.SvgWrapper(paths.SvgVial);
exports.VibratingBall = exports.SvgWrapper(paths.SvgVibratingBall);
exports.VileFluid = exports.SvgWrapper(paths.SvgVileFluid);
exports.VineFlower = exports.SvgWrapper(paths.SvgVineFlower);
exports.VineLeaf = exports.SvgWrapper(paths.SvgVineLeaf);
exports.VineWhip = exports.SvgWrapper(paths.SvgVineWhip);
exports.VintageRobot = exports.SvgWrapper(paths.SvgVintageRobot);
exports.Viola = exports.SvgWrapper(paths.SvgViola);
exports.Violin = exports.SvgWrapper(paths.SvgViolin);
exports.Virus = exports.SvgWrapper(paths.SvgVirus);
exports.VisoredHelm = exports.SvgWrapper(paths.SvgVisoredHelm);
exports.Volcano = exports.SvgWrapper(paths.SvgVolcano);
exports.Vomiting = exports.SvgWrapper(paths.SvgVomiting);
exports.VoodooDoll = exports.SvgWrapper(paths.SvgVoodooDoll);
exports.Vortex = exports.SvgWrapper(paths.SvgVortex);
exports.Vulture = exports.SvgWrapper(paths.SvgVulture);
exports.WalkingBoot = exports.SvgWrapper(paths.SvgWalkingBoot);
exports.WaltherPpk = exports.SvgWrapper(paths.SvgWaltherPpk);
exports.WaspSting = exports.SvgWrapper(paths.SvgWaspSting);
exports.WaterBolt = exports.SvgWrapper(paths.SvgWaterBolt);
exports.WaterDrop = exports.SvgWrapper(paths.SvgWaterDrop);
exports.WaterSplash = exports.SvgWrapper(paths.SvgWaterSplash);
exports.WaveCrest = exports.SvgWrapper(paths.SvgWaveCrest);
exports.WaveStrike = exports.SvgWrapper(paths.SvgWaveStrike);
exports.Waves = exports.SvgWrapper(paths.SvgWaves);
exports.WavyChains = exports.SvgWrapper(paths.SvgWavyChains);
exports.WavyItinerary = exports.SvgWrapper(paths.SvgWavyItinerary);
exports.WaxSeal = exports.SvgWrapper(paths.SvgWaxSeal);
exports.WebSpit = exports.SvgWrapper(paths.SvgWebSpit);
exports.WeightCrush = exports.SvgWrapper(paths.SvgWeightCrush);
exports.Werewolf = exports.SvgWrapper(paths.SvgWerewolf);
exports.Wheat = exports.SvgWrapper(paths.SvgWheat);
exports.Whip = exports.SvgWrapper(paths.SvgWhip);
exports.Whiplash = exports.SvgWrapper(paths.SvgWhiplash);
exports.WhirlpoolShuriken = exports.SvgWrapper(paths.SvgWhirlpoolShuriken);
exports.Whirlwind = exports.SvgWrapper(paths.SvgWhirlwind);
exports.WhiteBook = exports.SvgWrapper(paths.SvgWhiteBook);
exports.WhiteTower = exports.SvgWrapper(paths.SvgWhiteTower);
exports.WideArrowDunk = exports.SvgWrapper(paths.SvgWideArrowDunk);
exports.Wildfires = exports.SvgWrapper(paths.SvgWildfires);
exports.WilliamTell = exports.SvgWrapper(paths.SvgWilliamTell);
exports.WilliamTellSkull = exports.SvgWrapper(paths.SvgWilliamTellSkull);
exports.WinchesterRifle = exports.SvgWrapper(paths.SvgWinchesterRifle);
exports.WindHole = exports.SvgWrapper(paths.SvgWindHole);
exports.WindSlap = exports.SvgWrapper(paths.SvgWindSlap);
exports.WindyStripes = exports.SvgWrapper(paths.SvgWindyStripes);
exports.WineGlass = exports.SvgWrapper(paths.SvgWineGlass);
exports.WingCloak = exports.SvgWrapper(paths.SvgWingCloak);
exports.WingedArrow = exports.SvgWrapper(paths.SvgWingedArrow);
exports.WingedEmblem = exports.SvgWrapper(paths.SvgWingedEmblem);
exports.WingedLeg = exports.SvgWrapper(paths.SvgWingedLeg);
exports.WingedShield = exports.SvgWrapper(paths.SvgWingedShield);
exports.WingedSword = exports.SvgWrapper(paths.SvgWingedSword);
exports.Wingfoot = exports.SvgWrapper(paths.SvgWingfoot);
exports.WitchFace = exports.SvgWrapper(paths.SvgWitchFace);
exports.WitchFlight = exports.SvgWrapper(paths.SvgWitchFlight);
exports.WizardStaff = exports.SvgWrapper(paths.SvgWizardStaff);
exports.WolfHead = exports.SvgWrapper(paths.SvgWolfHead);
exports.WolfHowl = exports.SvgWrapper(paths.SvgWolfHowl);
exports.WolfTrap = exports.SvgWrapper(paths.SvgWolfTrap);
exports.WolverineClaws = exports.SvgWrapper(paths.SvgWolverineClaws);
exports.WoodAxe = exports.SvgWrapper(paths.SvgWoodAxe);
exports.WoodenDoor = exports.SvgWrapper(paths.SvgWoodenDoor);
exports.WoodenFence = exports.SvgWrapper(paths.SvgWoodenFence);
exports.WoodenHelmet = exports.SvgWrapper(paths.SvgWoodenHelmet);
exports.WoodenSign = exports.SvgWrapper(paths.SvgWoodenSign);
exports.World = exports.SvgWrapper(paths.SvgWorld);
exports.WormMouth = exports.SvgWrapper(paths.SvgWormMouth);
exports.WorriedEyes = exports.SvgWrapper(paths.SvgWorriedEyes);
exports.WrappedHeart = exports.SvgWrapper(paths.SvgWrappedHeart);
exports.WrappedSweet = exports.SvgWrapper(paths.SvgWrappedSweet);
exports.WrappingStar = exports.SvgWrapper(paths.SvgWrappingStar);
exports.WreckingBall = exports.SvgWrapper(paths.SvgWreckingBall);
exports.Wrench = exports.SvgWrapper(paths.SvgWrench);
exports.Wyvern = exports.SvgWrapper(paths.SvgWyvern);
exports.ZebraShield = exports.SvgWrapper(paths.SvgZebraShield);
exports.Zeppelin = exports.SvgWrapper(paths.SvgZeppelin);
exports.ZeusSword = exports.SvgWrapper(paths.SvgZeusSword);
exports.ZigArrow = exports.SvgWrapper(paths.SvgZigArrow);
exports.ZigzagCage = exports.SvgWrapper(paths.SvgZigzagCage);
exports.ZigzagLeaf = exports.SvgWrapper(paths.SvgZigzagLeaf);
exports.ZigzagTune = exports.SvgWrapper(paths.SvgZigzagTune);
